import React, { useState, useEffect, useRef } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import 'core-js/modules/es6.regexp.search.js';
import 'core-js/modules/es6.object.keys.js';
import 'core-js/modules/es6.regexp.match.js';
import 'core-js/modules/es6.regexp.split.js';
import 'core-js/modules/es6.array.slice.js';
import 'core-js/modules/es7.array.includes.js';
import 'core-js/modules/es6.regexp.replace.js';
import 'core-js/modules/es6.number.constructor.js';
import 'core-js/modules/es6.array.map.js';
import 'core-js/modules/es6.number.is-nan.js';
import 'core-js/modules/es6.string.includes.js';
import 'core-js/modules/es6.function.name.js';
import 'core-js/modules/es6.object.to-string.js';
import 'core-js/modules/es6.array.iterator.js';
import 'core-js/modules/web.dom.iterable.js';
import md from 'markdown-ast';
import 'core-js/modules/es6.regexp.to-string.js';
import 'core-js/modules/es6.math.sign.js';
import 'core-js/modules/es6.regexp.constructor.js';
import 'core-js/modules/es6.array.find.js';
import 'core-js/modules/es6.string.starts-with.js';

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var _templateObject$a;
var StyledButton = styled.div(_templateObject$a || (_templateObject$a = _taggedTemplateLiteral(["\n  font-size: 31px;\n  color: green;\n"])));

var ExampleComponent = function ExampleComponent(_ref) {
  var text = _ref.text;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(StyledButton, null, " ", text));
};

ExampleComponent.propTypes = {
  text: PropTypes.string
};

var HelloComponent = function HelloComponent(props) {
  return /*#__PURE__*/React.createElement("div", null, "Hello user: ", props.userName, " ! ", props.Age);
};

var searchEngineConfig = {
  google: {
    p: 'q',
    n: 'google',
    regex: true
  },
  'yahoo.com': {
    p: 'p',
    n: 'yahoo'
  },
  'msn.com': {
    p: 'q',
    n: 'msn'
  },
  'bing.com': {
    p: 'q',
    n: 'bing'
  },
  'duckduckgo.com': {
    n: 'duckduckgo'
  },
  'daum.net': {
    p: 'q',
    n: 'daum'
  },
  'eniro.se': {
    p: 'search_word',
    n: 'eniro '
  },
  'naver.com': {
    p: 'query',
    n: 'naver '
  },
  'aol.com': {
    p: 'q',
    n: 'aol'
  },
  'lycos.com': {
    p: 'q',
    n: 'lycos'
  },
  'ask.com': {
    p: 'q',
    n: 'ask'
  },
  'altavista.com': {
    p: 'q',
    n: 'altavista'
  },
  'search.netscape.com': {
    p: 'query',
    n: 'netscape'
  },
  'cnn.com': {
    p: 'query',
    n: 'cnn'
  },
  'about.com': {
    p: 'terms',
    n: 'about'
  },
  'mamma.com': {
    p: 'query',
    n: 'mama'
  },
  'alltheweb.com': {
    p: 'q',
    n: 'alltheweb'
  },
  'voila.fr': {
    p: 'rdata',
    n: 'voila'
  },
  'search.virgilio.it': {
    p: 'qs',
    n: 'virgilio'
  },
  'baidu.com': {
    p: 'wd',
    n: 'baidu'
  },
  'alice.com': {
    p: 'qs',
    n: 'alice'
  },
  'yandex.com': {
    p: 'text',
    n: 'yandex'
  },
  'najdi.org.mk': {
    p: 'q',
    n: 'najdi'
  },
  'seznam.cz': {
    p: 'q',
    n: 'seznam'
  },
  'search.com': {
    p: 'q',
    n: 'search'
  },
  'wp.pl': {
    p: 'szukaj ',
    n: 'wirtulana polska'
  },
  'online.onetcenter.org': {
    p: 'qt',
    n: 'o*net'
  },
  'szukacz.pl': {
    p: 'q',
    n: 'szukacz'
  },
  'yam.com': {
    p: 'k',
    n: 'yam'
  },
  'pchome.com': {
    p: 'q',
    n: 'pchome'
  },
  'kvasir.no': {
    p: 'q',
    n: 'kvasir'
  },
  'sesam.no': {
    p: 'q',
    n: 'sesam'
  },
  'ozu.es': {
    p: 'q',
    n: 'ozu '
  },
  'terra.com': {
    p: 'query',
    n: 'terra'
  },
  'mynet.com': {
    p: 'q',
    n: 'mynet'
  },
  'ekolay.net': {
    p: 'q',
    n: 'ekolay'
  },
  'rambler.ru': {
    p: 'words',
    n: 'rambler'
  }
};
var paidUrlParamsConfig = {
  gclid: {
    source: 'google',
    medium: 'cpc'
  },
  dclid: {
    source: 'google',
    medium: 'cpm'
  },
  fbclid: {
    source: 'facebook',
    medium: 'cpc'
  },
  msclkid: {
    source: 'bing',
    medium: 'cpc'
  },
  gclsrc: {
    source: 'google',
    medium: 'cpc'
  },
  wbraid: {
    source: 'google',
    medium: 'cpc'
  },
  gbraid: {
    source: 'google',
    medium: 'cpc'
  }
};
function rawData() {
  // this bit strips the protocol away from referrer, since psl doesn't want that
  var referrer = document.referrer; // get only the top level domain of referrer

  var referringDomain = getDomain_(referrer || document.location.href); // get url parameters

  var urlParams = new URLSearchParams(window.location.search); // then turn them into an object with key: value pairs

  var urlParamsObject = Object.fromEntries(urlParams); // gets only utm tags from url parameters

  var utmTags = getUtmTags(urlParamsObject); // checks for click identifiers in url parameters, and if present, results in cpc/cpm

  var paidUrlData = getPaidUrlData(urlParamsObject, paidUrlParamsConfig); // checks referring domain for common search engines, and when found, results in organic

  var searchEngineData = getSearchEngineData(referringDomain, urlParamsObject, searchEngineConfig); // set referring domain if present

  var referralData = referringDomain == null ? null : {
    medium: 'referral',
    source: referringDomain
  };
  return {
    this_hostname: document.location.origin || 'localhost',
    this_domain: getDomain_(document.location.origin) || 'localhost',
    referring_hostname: referrer || null,
    referring_domain: referringDomain,
    query_string: window.location.search,
    utm_tags: utmTags,
    url_params: Object.keys(urlParamsObject).length > 0 ? urlParamsObject : null,
    paid_url_data: paidUrlData,
    organic_search_data: searchEngineData,
    referral_data: referralData
  };
}

/*
checks the url parameters for utm tags.
returns set tags.
if no utm tags are set, returns null.
*/
function getUtmTags(urlParamsObject) {
  var utmTagMap = {
    utm_source: 'source',
    utm_medium: 'medium',
    utm_campaign: 'campaign',
    utm_content: 'content',
    utm_term: 'term'
  }; // an empty object to store found utm tags

  var utmTagResults = {}; // iterate all url parameters, check if they are utm tags, and save in results if they are

  for (var _key in urlParamsObject) {
    var _hasOwnProperty = Object.prototype.hasOwnProperty.call(utmTagMap, _key);

    if (_hasOwnProperty) {
      utmTagResults[utmTagMap[_key]] = urlParamsObject[_key];
    }
  } // return found UTM tags, or null if empty


  if (Object.keys(utmTagResults).length > 0) return utmTagResults;else return null;
}

/*
Checks referring domain for common search engines.
If a search query parameter is also passed, the value is used in 'term'
*/
function getSearchEngineData(referringDomain, urlParamsObject, searchEngineConfig) {
  if (referringDomain == null) return null;
  var hasOwnProperty = Object.prototype.hasOwnProperty.call(searchEngineConfig, referringDomain);

  if (hasOwnProperty) {
    var returnData = {
      source: searchEngineConfig[referringDomain]['n'],
      medium: 'organic'
    };
    var search_p = searchEngineConfig[referringDomain]['p'] || '';

    var _hasOwnProperty2 = Object.prototype.hasOwnProperty.call(urlParamsObject, search_p);

    if (_hasOwnProperty2) returnData['term'] = urlParamsObject[search_p];
    return returnData;
  } // This bit takes only those searchEngineConfigs where regex == true
  // if referring domain isn't otherwise found, we will match against regex, but only then


  var filteredSearchEngineConfig = Object.keys(searchEngineConfig).reduce(function (r, e) {
    if (searchEngineConfig[e]['regex']) r[e] = searchEngineConfig[e];
    return r;
  }, {});

  for (var _key2 in filteredSearchEngineConfig) {
    if (referringDomain.match(_key2) != null) {
      return {
        source: searchEngineConfig[_key2]['n'],
        medium: 'organic'
      };
    }
  }

  return null;
}

/*
 * Check the URL parameters for known click ID's.
 * If found, return the source and cpc/cpm
 */
function getPaidUrlData(urlParamsObject, paidUrlParamsConfig) {
  // Return first Click Id config found. There should never be more than one anyway.
  for (var _key3 in urlParamsObject) {
    var _hasOwnProperty3 = Object.prototype.hasOwnProperty.call(paidUrlParamsConfig, _key3);

    if (_hasOwnProperty3) {
      return paidUrlParamsConfig[_key3];
    }
  } // If no Click Id is found, return an empty array


  return null;
}

function get() {
  var trafficData = rawData(); // Are UTM tags present?

  return trafficData.utm_tags || // or is the traffic paid?
  trafficData.paid_url_data || // is it an organic search engine traffic?
  trafficData.organic_search_data || // or is it a referral?
  trafficData.referral_data || {
    // if not, it's direct
    source: '(direct)',
    medium: '(none)',
    campaign: '(not set)'
  };
}

function getDomain_(url) {
  var sanitizedURL = url.substring(0, 4) == 'http' ? url : "https://".concat(url);
  var u = new URL(sanitizedURL);
  var h = u.hostname;
  var s = h.split('.');
  var sl = s.slice(-2);

  if (['com', 'co'].includes(sl[0]) && sl.join('').length <= 5) {
    return s.slice(-3).join('.');
  }

  return s.slice(-2).join('.');
}

var _templateObject$9;
var MBox = styled.div(_templateObject$9 || (_templateObject$9 = _taggedTemplateLiteral(["\n  // reseting\n  margin: 0px;\n  padding: 0px;\n  box-sizing: border-box;\n\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n"])), function (_ref) {
  var $fontFamily = _ref.$fontFamily;
  return $fontFamily ? "font-family: ".concat($fontFamily) : null;
}, function (_ref2) {
  var $margin = _ref2.$margin;
  return $margin ? "margin: ".concat($margin) : null;
}, function (_ref3) {
  var $padding = _ref3.$padding;
  return $padding ? "padding: ".concat($padding) : null;
}, function (_ref4) {
  var $borderRadius = _ref4.$borderRadius;
  return $borderRadius ? "border-radius: ".concat($borderRadius) : null;
}, function (_ref5) {
  var $backgroundColor = _ref5.$backgroundColor;
  return $backgroundColor ? "background-color: ".concat($backgroundColor) : null;
}, function (_ref6) {
  var $width = _ref6.$width;
  return $width ? "width: ".concat($width) : null;
}, function (_ref7) {
  var $height = _ref7.$height;
  return $height ? "height: ".concat($height, "; min-height: ").concat($height, "; ") : null;
});

var cssVariables = {
  maxMobileWidth: '425px',
  lineHeight: 1.3,
  cvbMarkerTotalExtrusion: 2
};

var _templateObject$8;
var MText = styled.div(_templateObject$8 || (_templateObject$8 = _taggedTemplateLiteral(["\n  // reseting\n  margin: 0px;\n  padding: 0px;\n\n  display: ", ";\n  line-height: ", ";\n  font-family: ", " !important;\n  font-size: ", "px;\n  color: ", ";\n  font-weight: ", ";\n  font-style: ", ";\n  text-decoration: ", ";\n  text-align: ", ";\n  padding: ", ";\n  margin: ", ";\n\n  @media (max-width: ", ") {\n    font-size: ", "px;\n  }\n"])), function (props) {
  return props.isInlineText ? 'inline-block' : 'block';
}, cssVariables.lineHeight, function (props) {
  return props.$fontFamily;
}, function (props) {
  return props.$fontSize;
}, function (props) {
  return props.$color;
}, function (props) {
  return props.$fontWeight;
}, function (props) {
  return props.$fontStyle;
}, function (props) {
  return props.$textDecoration;
}, function (props) {
  return props.$textAlignment;
}, function (props) {
  return props.$padding;
}, function (props) {
  return props.$margin;
}, cssVariables.maxMobileWidth, function (props) {
  return props.$mobileFontSize;
});

var _templateObject$7, _templateObject2$4, _templateObject3$3, _templateObject4$3, _templateObject5$3, _templateObject6$3, _templateObject7$1, _templateObject8, _templateObject9, _templateObject10, _templateObject11;
var ProgressWidget = styled(MBox)(_templateObject$7 || (_templateObject$7 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  ", ";\n\n  @media (max-width: ", ") {\n    ", ";\n    ", ";\n  }\n"])), function (_ref) {
  var isBordered = _ref.isBordered,
      $borderWidth = _ref.$borderWidth,
      $borderColor = _ref.$borderColor;
  return isBordered ? "border-bottom: ".concat($borderWidth, "px solid ").concat($borderColor) : null;
}, cssVariables.maxMobileWidth, function (_ref2) {
  var $mobilePadding = _ref2.$mobilePadding;
  return "padding: ".concat($mobilePadding);
}, function (_ref3) {
  var $mobileMargin = _ref3.$mobileMargin;
  return "margin: ".concat($mobileMargin);
});
var ProgressBarWrapper = styled(MBox)(_templateObject2$4 || (_templateObject2$4 = _taggedTemplateLiteral(["\n  position: relative;\n"])));
var ProgressBar = styled(MBox)(_templateObject3$3 || (_templateObject3$3 = _taggedTemplateLiteral(["\n  display: block !important;\n  position: absolute;\n\n  // this is calculated by height of the amount text so that the marker and the bar intersect\n  top: ", "px;\n\n  &:after {\n    content: '';\n    display: block;\n    height: 100%;\n    background-color: ", ";\n    width: ", ";\n    border-radius: ", ";\n    transition: width 1s ease-out 0s;\n  }\n"])), function (_ref4) {
  var $top = _ref4.$top;
  return $top;
}, function (_ref5) {
  var $activeBgColor = _ref5.$activeBgColor;
  return $activeBgColor;
}, function (_ref6) {
  var $activeWidth = _ref6.$activeWidth;
  return $activeWidth;
}, function (_ref7) {
  var $borderRadius = _ref7.$borderRadius;
  return $borderRadius;
});
var Line = styled(MBox)(_templateObject4$3 || (_templateObject4$3 = _taggedTemplateLiteral(["\n  display: ", " !important;\n  border-right: 2px solid ", ";\n"])), function (_ref8) {
  var isHidden = _ref8.isHidden;
  return isHidden ? 'none' : 'block';
}, function (_ref9) {
  var $color = _ref9.$color;
  return $color;
});
var ProgressContentCon = styled(MBox)(_templateObject5$3 || (_templateObject5$3 = _taggedTemplateLiteral(["\n  position: relative;\n"])));
var ProgressContent = styled(MBox)(_templateObject6$3 || (_templateObject6$3 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  position: absolute;\n  // transform: translate(-50%);\n  left: ", ";\n  &:dir(rtl) {\n    right: ", ";\n    left: auto;\n  }\n  &:dir(ltr) {\n    left: ", ";\n  }\n"])), function (props) {
  return props.directionValue;
}, function (props) {
  return props.directionValue;
}, function (props) {
  return props.directionValue;
});
var TilesMilestonesWrapper = styled(MBox)(_templateObject7$1 || (_templateObject7$1 = _taggedTemplateLiteral(["\n  display: flex;\n  gap: 8px;\n"])));
var TilesMilestoneContainer = styled(MBox)(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  width: ", ";\n"])), function (props) {
  return props.$width;
});
var TilesMilestoneProgressbarWrapper = styled(MBox)(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  position: relative;\n  width: 100%;\n  background: ", ";\n  height: 9.94px;\n  border-radius: 13.1px;\n  overflow: hidden;\n"])), function (props) {
  return props.$backgroundColor;
});
var TilesMileStoneProgressbar = styled(MBox)(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n  display: block !important;\n  width: ", ";\n  background: ", ";\n  height: 100%;\n  transition: ", ";\n"])), function (props) {
  return props.$width;
}, function (props) {
  return props.$backgroundColor;
}, function (props) {
  return props.$transition;
});
var ProgressContentText = styled(MText)(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n  ", ";\n  text-wrap: ", ";\n  white-space: ", ";\n"])), function (_ref10) {
  var isHidden = _ref10.isHidden;
  return isHidden ? 'visibility: hidden' : null;
}, function (props) {
  return props.$textWrap;
}, function (props) {
  return props.$whiteSpace;
});

var sanitizeThemeStyleByNumber = function sanitizeThemeStyleByNumber(inputWidthProp) {
  return !Number.isNaN(Number(inputWidthProp)) ? "".concat(inputWidthProp, "px") : inputWidthProp;
};
var getSeparatedStyleValueArr = function getSeparatedStyleValueArr(valStr) {
  return valStr.split(' ').map(function (val) {
    return Number(val.replace('px', ''));
  });
};

var _templateObject$6, _templateObject2$3, _templateObject3$2, _templateObject4$2, _templateObject5$2, _templateObject6$2, _templateObject7;
var WidgetContainer = styled.div(_templateObject$6 || (_templateObject$6 = _taggedTemplateLiteral(["\n  width: 100%;\n  align-items: center;\n  justify-content: space-between;\n  border-radius: 12px;\n  background-color: ", ";\n  margin: ", ";\n  padding: ", ";\n  border-style: solid;\n  border-width: ", "px;\n  border-color: ", ";\n  width: ", "px;\n  min-height: ", "px;\n\n  .mr-vd-group-footer__button {\n    flex-shrink: 0;\n  }\n"])), function (_ref) {
  var bgColor = _ref.bgColor;
  return bgColor;
}, function (_ref2) {
  var margin = _ref2.margin;
  return margin;
}, function (_ref3) {
  var padding = _ref3.padding;
  return padding;
}, function (_ref4) {
  var borderWidth = _ref4.borderWidth;
  return borderWidth;
}, function (_ref5) {
  var borderColor = _ref5.borderColor;
  return borderColor;
}, function (_ref6) {
  var width = _ref6.width;
  return width;
}, function (_ref7) {
  var height = _ref7.height;
  return height;
});
var FlexDiv = styled.div(_templateObject2$3 || (_templateObject2$3 = _taggedTemplateLiteral(["\n  display: flex;\n  width: ", ";\n  height: ", ";\n  flex-direction: ", ";\n  align-items: ", ";\n  gap: ", ";\n  justify-content: ", ";\n  margin: ", ";\n  padding: ", ";\n  flex-wrap: ", ";\n"])), function (_ref8) {
  var width = _ref8.width;
  return width;
}, function (_ref9) {
  var height = _ref9.height;
  return height;
}, function (_ref10) {
  var flexDir = _ref10.flexDir;
  return flexDir;
}, function (_ref11) {
  var ai = _ref11.ai;
  return ai;
}, function (_ref12) {
  var gap = _ref12.gap;
  return gap;
}, function (_ref13) {
  var jc = _ref13.jc;
  return jc;
}, function (_ref14) {
  var margin = _ref14.margin;
  return margin;
}, function (_ref15) {
  var padding = _ref15.padding;
  return padding;
}, function (_ref16) {
  var flexWrap = _ref16.flexWrap;
  return flexWrap;
});
styled.p(_templateObject3$2 || (_templateObject3$2 = _taggedTemplateLiteral(["\n  font-size: ", "px;\n  font-style: ", ";\n  font-weight: ", ";\n  font-family: ", ";\n  line-height: ", "px;\n  padding: ", ";\n  margin: ", ";\n  color: ", ";\n  text-align: ", ";\n  text-decoration: ", ";\n  text-transform: uppercase;\n"])), function (_ref17) {
  var fontSize = _ref17.fontSize;
  return fontSize;
}, function (_ref18) {
  var fontStyle = _ref18.fontStyle;
  return fontStyle;
}, function (_ref19) {
  var fontWeight = _ref19.fontWeight;
  return fontWeight;
}, function (_ref20) {
  var fontFamily = _ref20.fontFamily;
  return fontFamily;
}, function (_ref21) {
  var lineHeight = _ref21.lineHeight;
  return lineHeight;
}, function (_ref22) {
  var padding = _ref22.padding;
  return padding;
}, function (_ref23) {
  var margin = _ref23.margin;
  return margin;
}, function (_ref24) {
  var color = _ref24.color;
  return color;
}, function (_ref25) {
  var textAlignment = _ref25.textAlignment;
  return textAlignment;
}, function (_ref26) {
  var textDecoration = _ref26.textDecoration;
  return textDecoration;
});
styled.div(_templateObject4$2 || (_templateObject4$2 = _taggedTemplateLiteral(["\n  font-size: ", "px;\n  font-style: ", ";\n  font-weight: ", ";\n  font-family: ", ";\n  line-height: ", "px;\n  padding: ", ";\n  margin: ", ";\n  color: ", ";\n  text-align: ", ";\n  text-decoration: ", ";\n  width: ", ";\n  word-wrap: break-word;\n  overflow-wrap: break-word;\n  white-space: normal;\n"])), function (_ref27) {
  var fontSize = _ref27.fontSize;
  return fontSize;
}, function (_ref28) {
  var fontStyle = _ref28.fontStyle;
  return fontStyle;
}, function (_ref29) {
  var fontWeight = _ref29.fontWeight;
  return fontWeight;
}, function (_ref30) {
  var fontFamily = _ref30.fontFamily;
  return fontFamily;
}, function (_ref31) {
  var lineHeight = _ref31.lineHeight;
  return lineHeight;
}, function (_ref32) {
  var padding = _ref32.padding;
  return padding;
}, function (_ref33) {
  var margin = _ref33.margin;
  return margin;
}, function (_ref34) {
  var color = _ref34.color;
  return color;
}, function (_ref35) {
  var textAlignment = _ref35.textAlignment;
  return textAlignment;
}, function (_ref36) {
  var textDecoration = _ref36.textDecoration;
  return textDecoration;
}, function (_ref37) {
  var width = _ref37.width;
  return width;
});
styled.div(_templateObject5$2 || (_templateObject5$2 = _taggedTemplateLiteral(["\n  height: 100%;\n"])));
var Button$1 = styled.button(_templateObject6$2 || (_templateObject6$2 = _taggedTemplateLiteral(["\n  cursor: pointer;\n  height: ", "px;\n  width: ", "px;\n  padding: ", ";\n  margin: ", ";\n  background-color: ", ";\n  border-radius: ", "px;\n  border: ", ";\n\n  font-size: ", "px;\n  font-style: ", ";\n  font-weight: ", ";\n  font-family: ", ";\n  line-height: ", "px;\n  color: ", ";\n  text-align: ", ";\n  text-decoration: ", ";\n"])), function (_ref38) {
  var height = _ref38.height;
  return height;
}, function (_ref39) {
  var width = _ref39.width;
  return width;
}, function (_ref40) {
  var padding = _ref40.padding;
  return padding;
}, function (_ref41) {
  var margin = _ref41.margin;
  return margin;
}, function (_ref42) {
  var bgColor = _ref42.bgColor,
      buttonStyle = _ref42.buttonStyle;
  return buttonStyle === 'filled' ? bgColor : 'transparent';
}, function (_ref43) {
  var radius = _ref43.radius;
  return radius;
}, function (_ref44) {
  var buttonStyle = _ref44.buttonStyle,
      color = _ref44.color;
  return buttonStyle === 'line' ? "2px solid ".concat(color) : 'none';
}, function (_ref45) {
  var fontSize = _ref45.fontSize;
  return fontSize;
}, function (_ref46) {
  var fontStyle = _ref46.fontStyle;
  return fontStyle;
}, function (_ref47) {
  var fontWeight = _ref47.fontWeight;
  return fontWeight;
}, function (_ref48) {
  var fontFamily = _ref48.fontFamily;
  return fontFamily;
}, function (_ref49) {
  var lineHeight = _ref49.lineHeight;
  return lineHeight;
}, function (_ref50) {
  var color = _ref50.color;
  return color;
}, function (_ref51) {
  var textAlignment = _ref51.textAlignment;
  return textAlignment;
}, function (_ref52) {
  var textDecoration = _ref52.textDecoration;
  return textDecoration;
});
styled.div(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  width: 22px;\n  height: 2px;\n  border-radius: 30px;\n  background-color: white;\n"])));

var _templateObject$5;

var _excluded = ["children"];
var polarisStyles = {
  success: '#008060',
  critical: '#D82C0D',
  warning: '#2C6ECB',
  yellow: '#8F6901',
  subdued: '#6D7175',
  'text-inverse': '',
  blue: '#2C6ECB',
  info: '#2C6ECB',
  monochrome: '#000000',
  white: '#FFFFFF',
  center: 'center',
  end: 'right',
  right: 'right',
  start: 'left',
  regular: '400',
  medium: '500',
  semibold: '600',
  bold: '700',
  ceHeadingMd: '1.2rem',
  ceHeading2xl: '1.9rem',
  headingXs: '0.75rem',
  headingSm: '0.875rem',
  headingMd: '1.3rem',
  headingLg: '1.4rem',
  headingXl: '1.6rem',
  heading2xl: '1.75rem',
  heading3xl: '2rem',
  heading4xl: '2.4rem',
  bodySm: '0.75rem',
  bodyMd: '0.875rem',
  bodyLg: '1rem',
  responsiveFontSizes: {
    headingLg: '1rem',
    headingXl: '1.25rem',
    heading2xl: '1.5rem',
    heading3xl: '1.75rem',
    heading4xl: '2rem'
  }
};
var CETextAlignmentValues = [{
  displayValue: 'Left',
  value: 'left',
  actualValue: 'start'
}, {
  displayValue: 'Center',
  value: 'center',
  actualValue: 'center'
}, {
  displayValue: 'Right',
  value: 'right',
  actualValue: 'end'
}];
CETextAlignmentValues.reduce(function (acc, size) {
  var newAcc = _objectSpread2({}, acc);

  newAcc[size.value] = size.actualValue;
  return newAcc;
}, {});
function Text$1(_ref) {
  var children = _ref.children,
      props = _objectWithoutProperties(_ref, _excluded);

  var StyledComponent = styled(props.as || 'p')(_templateObject$5 || (_templateObject$5 = _taggedTemplateLiteral(["\n    color: ", ";\n    text-align: ", ";\n    font-weight: ", ";\n    font-size: ", ";\n    font-family: ", ";\n    // margin: ", ";\n    padding: ", ";\n    text-transform: ", ";\n    width: ", ";\n    min-width: ", ";\n    border-bottom: ", ";\n    cursor: ", ";\n    border-bottom: ", ";\n    font-style: ", ";\n    line-height: ", ";\n    margin: 0;\n    @media (max-width: 768px) {\n      font-size: ", ";\n    }\n  "])), function (p) {
    return p.$color ? p.$color : '#202223';
  }, function (p) {
    return p.$alignment ? polarisStyles[p.$alignment] : 'left';
  }, function (p) {
    return p.$fontWeight ? polarisStyles[p.$fontWeight] : '400';
  }, function (p) {
    return p.$variant ? p.$variant : '1.6rem';
  }, function (p) {
    return p.$fontFamily ? p.$fontFamily : null;
  }, function (p) {
    return p.$margin ? p.$margin : null;
  }, function (p) {
    return p.$padding ? p.$padding : null;
  }, function (p) {
    return p.$textTransform ? p.$textTransform : null;
  }, function (p) {
    return p.$width ? p.$width : null;
  }, function (p) {
    return p.$minWidth ? p.$minWidth : null;
  }, function (p) {
    return p.$borderBottom ? '1px solid #babfc3' : null;
  }, function (p) {
    return p.$cursor ? p.$cursor : 'auto';
  }, function (p) {
    return p.$borderBottom ? p.$borderBottom : null;
  }, function (p) {
    return p.$fontStyle ? p.$fontStyle : '';
  }, function (p) {
    return p.$lineHeight;
  }, function (p) {
    return p.$variant ? polarisStyles.responsiveFontSizes[p.$variant] : polarisStyles[p.$variant];
  });
  return /*#__PURE__*/React.createElement(StyledComponent, {
    $fontWeight: props.fontWeight,
    $fontFamily: props.fontFamily,
    $color: props.color,
    $alignment: props.alignment,
    $variant: props.variant,
    $margin: props.margin,
    $padding: props.padding,
    $textTransform: props.textTransform,
    $width: props.width,
    $minWidth: props.minWidth,
    $borderBottom: props.borderBottom,
    $cursor: props.cursor,
    $fontStyle: props.fontStyle,
    $lineHeight: props.lineHeight
  }, children);
}

var getMdComponentAst = function getMdComponentAst(ast) {
  var components = {
    title: {
      component: 'heading',
      type: 'block',
      attributes: [{
        key: 'rank',
        value: 'level'
      }]
    },
    text: {
      component: 'paragraph',
      type: 'component'
    },
    textWithBlock: {
      component: 'paragraph',
      type: 'block'
    },
    italic: {
      component: 'italic',
      type: 'block',
      properties: {
        fontStyle: 'italic'
      }
    },
    bold: {
      component: 'bold',
      type: 'block',
      properties: {
        fontWeight: '700'
      }
    },
    break: {
      component: 'break',
      type: 'component'
    }
  };
  var componentAst = []; // creating a new ast based on our logic to concatenate all the blocks in one single array

  addLineBreaksInMdAst(ast).forEach(function (node) {
    var nodeType = node.type;
    var componentToUse = components[nodeType]; // check if component is not found then use default ones

    if (!componentToUse) {
      nodeType = node !== null && node !== void 0 && node.block ? 'textWithBlock' : 'text';
      componentToUse = components[nodeType];
    }

    var _componentToUse = componentToUse,
        properties = _componentToUse.properties,
        attributes = _componentToUse.attributes,
        component = _componentToUse.component; // creating a sub node with component and properties
    // sub node is basically a new node with modified properties

    var subNode = {
      component: component
    }; // looping over all the attributes to extract property from node and reassign with different key
    // eslint-disable-next-line no-unused-expressions

    attributes === null || attributes === void 0 ? void 0 : attributes.forEach(function (attribute) {
      subNode[attribute.value] = node[attribute.key];
    });
    if (properties) subNode.props = properties; //  we again recursively call the function to get the block nodes
    // blocks are same as of nodes

    if (components[nodeType].type === 'block' && node.block) {
      subNode.blocks = getMdComponentAst(node.block.map(function (block) {
        return _objectSpread2(_objectSpread2({}, block), {}, {
          // we keep these fields same as parent ones to keep them unique
          // because blocks are normal blocks without any info about parents
          type: nodeType,
          rank: node.rank,
          bullet: node.bullet
        });
      }));
    } else {
      subNode.content = (node === null || node === void 0 ? void 0 : node.text) || '';
    }

    subNode.bullet = (node === null || node === void 0 ? void 0 : node.bullet) || '';
    componentAst.push(subNode);
  });
  return componentAst;
}; // creates a new ast with line breaks as separate nodes all line breaks are extracted from strings


var addLineBreaksInMdAst = function addLineBreaksInMdAst(ast) {
  var updatedAst = [];
  ast.forEach(function (node, i) {
    var _node$text, _ast;

    // checks for line breaks in the text
    if (node !== null && node !== void 0 && (_node$text = node.text) !== null && _node$text !== void 0 && _node$text.includes('\n')) {
      // split string by line breaks and add each line as a separate node
      var astWithBreaks = node.text.split('\n').reduce(function (acc, content, index) {
        // first push line break and then content
        if (index) acc.push('\n');
        if (content !== '') acc.push(content);
        return acc;
      }, []); // based on line breaks, add break or text nodes

      astWithBreaks.forEach(function (content) {
        updatedAst.push({
          type: content === '\n' ? 'break' : node.type,
          text: content
        });
      });
    } // checks for list followed by list because it should have a line break after every list item
    else if (node.type === 'list' && (ast === null || ast === void 0 ? void 0 : (_ast = ast[i + 1]) === null || _ast === void 0 ? void 0 : _ast.type) === 'list') {
      updatedAst.push(node);
      updatedAst.push({
        type: 'break',
        text: '\n'
      });
    } else updatedAst.push(node);
  });
  return updatedAst;
};

var Heading = function Heading(props) {
  return /*#__PURE__*/React.createElement(Text$1, _extends({
    fontWeight: "semibold"
  }, props));
};

var fontSizeValues = {
  extraSmall: 'headingSm',
  small: 'ceHeadingMd',
  base: 'headingLg',
  medium: 'headingXl',
  large: 'ceHeading2xl',
  extraLarge: 'heading3xl'
};
var textAlignValues = {
  left: 'start',
  center: 'center',
  right: 'end'
};
var MdComponentsConfig = {
  heading: {
    component: Heading,
    additionalProps: {
      level: {
        name: 'variant',
        values: {
          1: 'heading3xl',
          2: 'heading2xl',
          3: 'headingXl'
        }
      },
      alignment: {
        name: 'alignment',
        values: textAlignValues
      },
      color: {
        name: 'color'
      },
      fontFamily: {
        name: 'fontFamily'
      }
    }
  },
  paragraph: {
    component: Text$1,
    additionalProps: {
      fontSize: {
        name: 'variant',
        values: fontSizeValues
      },
      alignment: {
        name: 'alignment',
        values: textAlignValues
      },
      color: {
        name: 'color'
      },
      fontWeight: {
        name: 'fontWeight'
      },
      fontFamily: {
        name: 'fontFamily'
      }
    }
  },
  italic: {
    component: Text$1,
    props: {
      fontStyle: 'italic'
    },
    additionalProps: {
      fontSize: {
        name: 'variant',
        values: fontSizeValues
      },
      alignment: {
        name: 'alignment',
        values: textAlignValues
      },
      color: {
        name: 'color'
      },
      fontWeight: {
        name: 'fontWeight'
      },
      fontFamily: {
        name: 'fontFamily'
      }
    }
  },
  bold: {
    component: Text$1,
    props: {
      fontWeight: 'semibold'
    },
    additionalProps: {
      fontSize: {
        name: 'variant',
        values: fontSizeValues
      },
      alignment: {
        name: 'alignment',
        values: textAlignValues
      },
      color: {
        name: 'color'
      },
      fontWeight: {
        name: 'fontWeight'
      },
      fontFamily: {
        name: 'fontFamily'
      }
    }
  }
};

var getProps = function getProps(componentType, props) {
  var _MdComponentsConfig$c3;

  var componentProps = {};
  Object.keys(props).forEach(function (prop) {
    var _MdComponentsConfig$c, _MdComponentsConfig$c2;

    // based on props from config we extract additional props
    var propConfig = (_MdComponentsConfig$c = MdComponentsConfig[componentType]) === null || _MdComponentsConfig$c === void 0 ? void 0 : (_MdComponentsConfig$c2 = _MdComponentsConfig$c.additionalProps) === null || _MdComponentsConfig$c2 === void 0 ? void 0 : _MdComponentsConfig$c2[prop];

    if (propConfig) {
      // if prop exist we assign it to component props
      var propName = propConfig.name;
      componentProps[propName] = propConfig.values ? propConfig.values[props[prop]] : props[prop];
    }
  }); // extracting existing props from config

  var existingProps = ((_MdComponentsConfig$c3 = MdComponentsConfig[componentType]) === null || _MdComponentsConfig$c3 === void 0 ? void 0 : _MdComponentsConfig$c3.props) || {};
  return _objectSpread2(_objectSpread2({}, componentProps), existingProps);
};

var addSpacesInText = function addSpacesInText(text) {
  return text.replaceAll(' ', '\xa0<@wbr<@').split('<@');
}; // now from our own ast we extract components based on line breaks


var getMdComponentsFromMd = function getMdComponentsFromMd(mdAst) {
  var additionalProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  //  components are 2 level array, f
  // first level is for vertical displaying components
  // and inside first there's nested second level which is used to display components horizontally
  // [              ---> first level vertical
  //   ['level 1']           ---> second level horizontal
  //   ['level 2']
  // ],
  // [
  //  ['level 3']
  // ]
  // it will look something like this in preview
  // level 1 level 2
  // level 3
  var components = [[]]; // tracking index of second level of array

  var nestedComponentActiveIndex = 0;

  var handleBreak = function handleBreak(node) {
    var noOfEmptyLines = // - 2 because one break is used to change the line
    node.content.replaceAll('\n', 'b').split('b').length - 2;
    var areMultipleLineBreaks = noOfEmptyLines > 0; // if the nested array exist then we push a text element with
    // hidden white color for line break to be visible

    if (components[nestedComponentActiveIndex] && !areMultipleLineBreaks) components[nestedComponentActiveIndex].push( /*#__PURE__*/React.createElement("div", {
      style: {
        color: 'transparent'
      }
    }, "h")); // if there're multiple line breaks then push hidden text elem for each line break

    if (areMultipleLineBreaks) for (var index = 0; index < noOfEmptyLines; index += 1) {
      components.push([]); // after each line break we increment the index of nested array
      // so it goes to next line

      nestedComponentActiveIndex += 1;
      components[nestedComponentActiveIndex].push( /*#__PURE__*/React.createElement("div", {
        style: {
          color: 'transparent'
        }
      }, "h"));
    } // at last we again push an empty nested array so all other elements can be in same level

    components.push([]);
    nestedComponentActiveIndex += 1;
  };

  mdAst.forEach(function (node) {
    // if there're blocks we first concatenate all the blocks in one single array
    if (node.blocks) {
      node.blocks.forEach(function (block) {
        // handling breaks in block
        if (block.component === 'break') handleBreak(block);else {
          var ComponentToUse = MdComponentsConfig[block.component].component; // we extract all the component props from config which component needs

          var props = getProps(block.component, _objectSpread2(_objectSpread2({}, block), additionalProps));

          if (props.variant) {
            props.variant = polarisStyles[props.variant];
          } else {
            props.variant = additionalProps.fontSize;
          } // props.variant = additionalProps.fontSize;
          // at last we push nested components in nested array


          components[nestedComponentActiveIndex].push( /*#__PURE__*/React.createElement(ComponentToUse, props, block.bullet || '', ' ', addSpacesInText(block.content).map(function (text, i) {
            return text === 'wbr' ? /*#__PURE__*/React.createElement("wbr", null) : text;
          })));
        }
      });
    } else if (node.component === 'break') {
      handleBreak(node);
    } else {
      // if it's not a block we repeat above steps but for node
      var ComponentToUse = MdComponentsConfig[node.component].component;
      var props = getProps(node.component, _objectSpread2(_objectSpread2({}, node), additionalProps));

      if (props.variant) {
        props.variant = polarisStyles[props.variant];
      } else {
        props.variant = additionalProps.fontSize;
      }

      components[nestedComponentActiveIndex].push( /*#__PURE__*/React.createElement(ComponentToUse, props, node.bullet || '', ' ', addSpacesInText(node.content).map(function (text, i) {
        return text === 'wbr' ? /*#__PURE__*/React.createElement("wbr", null) : text;
      })));
    }
  });
  return components;
};

var getMd = function getMd() {
  var string = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var props = arguments.length > 1 ? arguments[1] : undefined;
  var alignment = arguments.length > 2 ? arguments[2] : undefined;
  var components = [];

  try {
    var ast = md(string); // returns md from library

    var mdd = getMdComponentAst(ast); // modifies md to our own ast

    components = getMdComponentsFromMd(mdd, props); // creating component tree from our mdd ast
  } catch (err) {
    console.log(err);
  }

  return /*#__PURE__*/React.createElement(FlexDiv, {
    flexDir: "column",
    ai: alignment,
    width: "100%"
  }, components.map(function (subComponents) {
    return (
      /*#__PURE__*/
      // eslint-disable-next-line react/jsx-key
      React.createElement(FlexDiv, {
        jc: alignment,
        flexWrap: "wrap"
      }, subComponents.map(function (component) {
        return component;
      }))
    );
  }));
};

var useMd = function useMd() {
  return function (string, props, alignment) {
    return getMd(string, props, alignment);
  };
};
Text$1.propTypes = {
  children: PropTypes.node.isRequired,
  as: PropTypes.string,
  variant: PropTypes.string,
  color: PropTypes.string,
  fontWeight: PropTypes.string,
  margin: PropTypes.string,
  padding: PropTypes.string,
  alignment: PropTypes.string,
  textTransform: PropTypes.string,
  width: PropTypes.string,
  minWidth: PropTypes.string,
  borderBottom: PropTypes.string,
  cursor: PropTypes.string,
  fontStyle: PropTypes.string,
  lineHeight: PropTypes.string,
  fontFamily: PropTypes.string
};

var MdText = function MdText(_ref) {
  var children = _ref.children,
      fontSize = _ref.fontSize,
      alignment = _ref.alignment,
      color = _ref.color,
      fontWeight = _ref.fontWeight,
      fontFamily = _ref.fontFamily;
  var md = useMd();
  return md(children, {
    fontSize: fontSize,
    alignment: alignment,
    color: color,
    fontWeight: fontWeight,
    fontFamily: fontFamily
  }, alignment);
};

var CVBCon = function CVBCon(_ref) {
  var isShowHeader = _ref.isShowHeader,
      offerHeaderBarBackgroundColor = _ref.offerHeaderBarBackgroundColor,
      offerHeaderBarPadding = _ref.offerHeaderBarPadding,
      offerHeaderBarMargin = _ref.offerHeaderBarMargin,
      headerTextColor = _ref.headerTextColor;
      _ref.headerFontSize;
      _ref.headerMobileFontSize;
      _ref.headerFontWeight;
      _ref.headerFontStyle;
      _ref.headerTextDecoration;
      var headerFontFamily = _ref.headerFontFamily,
      headerTextAlignment = _ref.headerTextAlignment,
      progressBarContainerMargin = _ref.progressBarContainerMargin,
      progressBarContainerPadding = _ref.progressBarContainerPadding,
      progressBarTopPlacement = _ref.progressBarTopPlacement,
      progressBarWidth = _ref.progressBarWidth,
      progressBarHeight = _ref.progressBarHeight,
      progressBarColor = _ref.progressBarColor,
      progressBarBorderRadius = _ref.progressBarBorderRadius,
      progressBarActiveColor = _ref.progressBarActiveColor,
      cartValue = _ref.cartValue,
      headerText = _ref.headerText,
      infoAmt = _ref.infoAmt,
      isTilesLayoutType = _ref.isTilesLayoutType,
      cvbHeaderFontSize = _ref.cvbHeaderFontSize,
      cvbTileTitleText = _ref.cvbTileTitleText,
      cvbTileTitleTextColor = _ref.cvbTileTitleTextColor,
      cvbTileTitleTextAlignment = _ref.cvbTileTitleTextAlignment,
      cvbTileTitleFontFamily = _ref.cvbTileTitleFontFamily,
      cvbTileTitleFontSize = _ref.cvbTileTitleFontSize,
      cvbTileTitleMargin = _ref.cvbTileTitleMargin,
      cvbTileTitlePadding = _ref.cvbTileTitlePadding,
      showTilesTitleHeader = _ref.showTilesTitleHeader,
      children = _ref.children;
  return /*#__PURE__*/React.createElement(React.Fragment, null, isShowHeader && isTilesLayoutType && showTilesTitleHeader() && /*#__PURE__*/React.createElement(MBox, {
    $backgroundColor: 'transparent',
    $padding: cvbTileTitlePadding,
    $margin: cvbTileTitleMargin
  }, /*#__PURE__*/React.createElement(MdText, {
    fontSize: "".concat(cvbTileTitleFontSize, "px"),
    alignment: cvbTileTitleTextAlignment,
    color: cvbTileTitleTextColor,
    fontWeight: "",
    fontFamily: cvbTileTitleFontFamily
  }, cvbTileTitleText)), isShowHeader && /*#__PURE__*/React.createElement(MBox, {
    $backgroundColor: offerHeaderBarBackgroundColor || '#A5B3C9',
    $padding: offerHeaderBarPadding,
    $margin: offerHeaderBarMargin,
    className: "mr-embedded-widget__offer-header-con"
  }, /*#__PURE__*/React.createElement(MdText, {
    fontSize: "".concat(cvbHeaderFontSize, "px"),
    alignment: headerTextAlignment,
    color: headerTextColor,
    fontWeight: "",
    fontFamily: headerFontFamily
  }, headerText.replace('{{infoAmount}}', infoAmt))), /*#__PURE__*/React.createElement(ProgressBarWrapper, {
    $margin: progressBarContainerMargin,
    $padding: progressBarContainerPadding,
    className: "mr-embedded-widget__progress-bar-con"
  }, !isTilesLayoutType && /*#__PURE__*/React.createElement(ProgressBar, {
    $top: progressBarTopPlacement,
    $width: sanitizeThemeStyleByNumber(progressBarWidth),
    $height: sanitizeThemeStyleByNumber(progressBarHeight),
    $backgroundColor: progressBarColor,
    $borderRadius: progressBarBorderRadius,
    $activeBgColor: progressBarActiveColor,
    $activeWidth: "".concat(cartValue * 100, "%"),
    className: "mr-progress-bar-con__bar"
  }), children));
};

var _templateObject$4;
var StyledImg = styled.img(_templateObject$4 || (_templateObject$4 = _taggedTemplateLiteral(["\n  ", "\n  ", "\n  ", "\n  ", "\n    height: ", ";\n  width: ", ";\n"])), function (props) {
  return props.$margin ? "margin: ".concat(props.$margin, ";") : null;
}, function (props) {
  return props.$borderSize && props.$borderColor ? "border: ".concat(props.$borderSize, "px solid ").concat(props.$borderColor, ";") : null;
}, function (props) {
  return props.$borderRadius ? "border-radius: ".concat(props.$borderRadius, "px;") : null;
}, function (props) {
  return props.$background ? "background-color: ".concat(props.$background, ";") : null;
}, function (props) {
  return props.$height;
}, function (props) {
  return props.$width;
});

function MImage(props) {
  var src = props.src,
      width = props.width,
      height = props.height,
      className = props.className,
      alt = props.alt,
      margin = props.margin,
      borderSize = props.borderSize,
      borderColor = props.borderColor,
      borderRadius = props.borderRadius,
      background = props.background;
  return /*#__PURE__*/React.createElement(StyledImg, {
    src: src,
    $width: width,
    $height: height,
    className: className,
    $margin: margin,
    $borderSize: borderSize,
    $borderColor: borderColor,
    $borderRadius: borderRadius,
    alt: alt,
    $background: background
  });
}

var runtime = {exports: {}};

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

(function (module) {
var runtime = (function (exports) {

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined$1; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  function define(obj, key, value) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
    return obj[key];
  }
  try {
    // IE 8 has a broken Object.defineProperty that only works on DOM objects.
    define({}, "");
  } catch (err) {
    define = function(obj, key, value) {
      return obj[key] = value;
    };
  }

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  exports.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = GeneratorFunctionPrototype;
  define(Gp, "constructor", GeneratorFunctionPrototype);
  define(GeneratorFunctionPrototype, "constructor", GeneratorFunction);
  GeneratorFunction.displayName = define(
    GeneratorFunctionPrototype,
    toStringTagSymbol,
    "GeneratorFunction"
  );

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      define(prototype, method, function(arg) {
        return this._invoke(method, arg);
      });
    });
  }

  exports.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  exports.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      define(genFun, toStringTagSymbol, "GeneratorFunction");
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  exports.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return PromiseImpl.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return PromiseImpl.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration.
          result.value = unwrapped;
          resolve(result);
        }, function(error) {
          // If a rejected Promise was yielded, throw the rejection back
          // into the async generator function so it can be handled there.
          return invoke("throw", error, resolve, reject);
        });
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new PromiseImpl(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  });
  exports.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    if (PromiseImpl === void 0) PromiseImpl = Promise;

    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList),
      PromiseImpl
    );

    return exports.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined$1) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        // Note: ["return"] must be used for ES3 parsing compatibility.
        if (delegate.iterator["return"]) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined$1;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined$1;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  define(Gp, toStringTagSymbol, "Generator");

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  define(Gp, iteratorSymbol, function() {
    return this;
  });

  define(Gp, "toString", function() {
    return "[object Generator]";
  });

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  exports.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined$1;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  exports.values = values;

  function doneResult() {
    return { value: undefined$1, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined$1;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined$1;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined$1;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined$1;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined$1;
      }

      return ContinueSentinel;
    }
  };

  // Regardless of whether this script is executing as a CommonJS module
  // or not, return the runtime object so that we can declare the variable
  // regeneratorRuntime in the outer scope, which allows this module to be
  // injected easily by `bin/regenerator --include-runtime script.js`.
  return exports;

}(
  // If this script is executing as a CommonJS module, use module.exports
  // as the regeneratorRuntime namespace. Otherwise create a new empty
  // object. Either way, the resulting object will be used to initialize
  // the regeneratorRuntime variable at the top of this file.
  module.exports 
));

try {
  regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
  // This module should not be running in strict mode, so the above
  // assignment should always work unless something is misconfigured. Just
  // in case runtime.js accidentally runs in strict mode, in modern engines
  // we can explicitly access globalThis. In older engines we can escape
  // strict mode using a global Function call. This could conceivably fail
  // if a Content Security Policy forbids using Function, but in that case
  // the proper solution is to fix the accidental strict mode problem. If
  // you've misconfigured your bundler to force strict mode and applied a
  // CSP to forbid Function, and you're not willing to fix either of those
  // problems, please detail your unique predicament in a GitHub issue.
  if (typeof globalThis === "object") {
    globalThis.regeneratorRuntime = runtime;
  } else {
    Function("r", "regeneratorRuntime = r")(runtime);
  }
}
}(runtime));

var images = {
  discount: function discount$1() {
    return Promise.resolve().then(function () { return discount; });
  },
  gift: function gift$1() {
    return Promise.resolve().then(function () { return gift; });
  },
  shipping: function shipping$1() {
    return Promise.resolve().then(function () { return shipping; });
  },
  spLogo: function spLogo$1() {
    return Promise.resolve().then(function () { return spLogo; });
  },
  downIcon: function downIcon$1() {
    return Promise.resolve().then(function () { return downIcon; });
  }
};

var useDynamicImage = function useDynamicImage(fileName) {
  var _useState = useState(true),
      _useState2 = _slicedToArray(_useState, 2),
      loading = _useState2[0],
      setLoading = _useState2[1];

  var _useState3 = useState(null),
      _useState4 = _slicedToArray(_useState3, 2),
      error = _useState4[0],
      setError = _useState4[1];

  var _useState5 = useState(''),
      _useState6 = _slicedToArray(_useState5, 2),
      image = _useState6[0],
      setImage = _useState6[1];

  useEffect(function () {
    var fetchImage = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var response;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                if (Object.prototype.hasOwnProperty.call(images, fileName)) {
                  _context.next = 5;
                  break;
                }

                setImage(fileName);
                _context.next = 9;
                break;

              case 5:
                _context.next = 7;
                return images[fileName]();

              case 7:
                response = _context.sent;
                // change relative path to suit your needs
                setImage(response.default);

              case 9:
                _context.next = 14;
                break;

              case 11:
                _context.prev = 11;
                _context.t0 = _context["catch"](0);
                setError(_context.t0);

              case 14:
                _context.prev = 14;
                setLoading(false);
                return _context.finish(14);

              case 17:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 11, 14, 17]]);
      }));

      return function fetchImage() {
        return _ref.apply(this, arguments);
      };
    }();

    fetchImage();
  }, [fileName]);
  return {
    loading: loading,
    error: error,
    image: image
  };
};

var CvbIcon = function CvbIcon(_ref) {
  var imageSrc = _ref.imageSrc,
      size = _ref.size,
      borderSize = _ref.borderSize,
      borderColor = _ref.borderColor,
      borderRadius = _ref.borderRadius,
      bg = _ref.bg;

  var _useDynamicImage = useDynamicImage(imageSrc),
      image = _useDynamicImage.image,
      loading = _useDynamicImage.loading,
      error = _useDynamicImage.error;

  if (error) return null;
  return !loading ? /*#__PURE__*/React.createElement(MImage, {
    borderSize: borderSize,
    borderColor: borderColor,
    borderRadius: borderRadius,
    src: image,
    alt: imageSrc ? imageSrc.toString() : 'custom-image',
    height: "".concat(size, "px"),
    width: "".concat(size, "px"),
    background: bg,
    className: "mr-cvb-icon"
  }) : null;
};

var SINGLE_MILESTONE_WIDTH = 35;

var isHideMilestone = function isHideMilestone(isShowMilestones, minText) {
  return !isShowMilestones || minText.trim() === '';
};

var IconMilestone = function IconMilestone(_ref) {
  var _getLayoutBasedMilestoneProps = _ref._getLayoutBasedMilestoneProps,
      idx = _ref.idx,
      item = _ref.item;

  var _getLayoutBasedMilest = _getLayoutBasedMilestoneProps(),
      isSingleMilestone = _getLayoutBasedMilest.isSingleMilestone,
      marks = _getLayoutBasedMilest.marks,
      progressContentWidth = _getLayoutBasedMilest.progressContentWidth,
      milestoneValueColor = _getLayoutBasedMilest.milestoneValueColor,
      milestoneValueFontSize = _getLayoutBasedMilest.milestoneValueFontSize,
      milestoneValueMobileFontSize = _getLayoutBasedMilest.milestoneValueMobileFontSize,
      milestoneValueFontWeight = _getLayoutBasedMilest.milestoneValueFontWeight,
      milestoneValueFontStyle = _getLayoutBasedMilest.milestoneValueFontStyle,
      milestoneValueTextDecoration = _getLayoutBasedMilest.milestoneValueTextDecoration,
      milestoneValueFontFamily = _getLayoutBasedMilest.milestoneValueFontFamily,
      milestoneValueTextAlignment = _getLayoutBasedMilest.milestoneValueTextAlignment,
      milestoneValuePadding = _getLayoutBasedMilest.milestoneValuePadding,
      milestoneValueMargin = _getLayoutBasedMilest.milestoneValueMargin,
      isShowMilestones = _getLayoutBasedMilest.isShowMilestones,
      isMobile = _getLayoutBasedMilest.isMobile,
      isShowMilestoneText = _getLayoutBasedMilest.isShowMilestoneText,
      milestoneTextColor = _getLayoutBasedMilest.milestoneTextColor,
      milestoneFontSize = _getLayoutBasedMilest.milestoneFontSize,
      milestoneMobileFontSize = _getLayoutBasedMilest.milestoneMobileFontSize,
      milestoneFontWeight = _getLayoutBasedMilest.milestoneFontWeight,
      milestoneFontStyle = _getLayoutBasedMilest.milestoneFontStyle,
      milestoneTextDecoration = _getLayoutBasedMilest.milestoneTextDecoration,
      milestoneFontFamily = _getLayoutBasedMilest.milestoneFontFamily,
      milestoneTextAlignment = _getLayoutBasedMilest.milestoneTextAlignment,
      milestonePadding = _getLayoutBasedMilest.milestonePadding,
      milestoneMargin = _getLayoutBasedMilest.milestoneMargin,
      iconMobileSize = _getLayoutBasedMilest.iconMobileSize,
      iconDesktopSize = _getLayoutBasedMilest.iconDesktopSize,
      iconMobileBorderSize = _getLayoutBasedMilest.iconMobileBorderSize,
      iconDesktopBorderSize = _getLayoutBasedMilest.iconDesktopBorderSize,
      iconBorderColor = _getLayoutBasedMilest.iconBorderColor,
      iconBorderRadius = _getLayoutBasedMilest.iconBorderRadius,
      max = _getLayoutBasedMilest.max,
      iconBackgroundColor = _getLayoutBasedMilest.iconBackgroundColor;

  return /*#__PURE__*/React.createElement(ProgressContent, {
    key: idx,
    className: "mr-progress-bar-con__item",
    ai: "center",
    flexDir: "column",
    directionValue: isSingleMilestone ? "".concat(100 - SINGLE_MILESTONE_WIDTH, "%") : "".concat(marks[idx].value * 100 / max, "%"),
    $width: progressContentWidth
  }, /*#__PURE__*/React.createElement(ProgressContentText, {
    $color: milestoneValueColor,
    $fontSize: milestoneValueFontSize,
    $mobileFontSize: milestoneValueMobileFontSize,
    $fontWeight: milestoneValueFontWeight,
    $fontStyle: milestoneValueFontStyle,
    $textDecoration: milestoneValueTextDecoration,
    $fontFamily: milestoneValueFontFamily,
    $textAlignment: milestoneValueTextAlignment,
    $padding: milestoneValuePadding,
    $margin: milestoneValueMargin,
    isHidden: isHideMilestone(isShowMilestones, item.minText),
    className: "mr-progress-bar-item__milestone",
    $textWrap: "nowrap",
    $whiteSpace: "nowrap"
  }, isHideMilestone(isShowMilestones, item.minText) ? 'placeholder' : item.minText), /*#__PURE__*/React.createElement(CvbIcon, {
    imageSrc: item.isCVBCustomIconEnabled && item.cvbCustomIconURL ? item.cvbCustomIconURL : item.cvbIcon,
    size: isMobile ? iconMobileSize : iconDesktopSize,
    borderSize: isMobile ? iconMobileBorderSize : iconDesktopBorderSize,
    borderColor: iconBorderColor,
    borderRadius: iconBorderRadius,
    bg: iconBackgroundColor
  }), isShowMilestoneText && /*#__PURE__*/React.createElement(ProgressContentText, {
    $color: milestoneTextColor,
    $fontSize: milestoneFontSize,
    $mobileFontSize: milestoneMobileFontSize,
    $fontWeight: milestoneFontWeight,
    $fontStyle: milestoneFontStyle,
    $textDecoration: milestoneTextDecoration,
    $fontFamily: milestoneFontFamily,
    $textAlignment: milestoneTextAlignment,
    $padding: milestonePadding,
    $margin: milestoneMargin,
    className: "mr-progress-bar-item__reward",
    $textWrap: "wrap",
    $whiteSpace: "normal"
  }, item.milestoneText));
};

var CVBIconLayout = function CVBIconLayout(_ref) {
  var layoutProps = _ref.layoutProps,
      milestones = _ref.milestones,
      progressContentConHeight = _ref.progressContentConHeight,
      getLayoutBasedMilestoneProps = _ref.getLayoutBasedMilestoneProps;
  return /*#__PURE__*/React.createElement(ProgressWidget, {
    $fontFamily: layoutProps.font,
    $backgroundColor: layoutProps.offerBackgroundColor,
    isBordered: layoutProps.isOfferBordered,
    $borderColor: layoutProps.offerBorderColor,
    $borderWidth: layoutProps.offerBorderWidth,
    $borderRadius: layoutProps.offerBorderRadius,
    $padding: layoutProps.offerPadding,
    $mobilePadding: layoutProps.offerMobilePadding,
    $margin: layoutProps.offerMargin,
    $mobileMargin: layoutProps.offerMobileMargin,
    className: "mr-embedded-widget mr-embedded-widget--cvb mr-embedded-widget--icon"
  }, /*#__PURE__*/React.createElement(CVBCon, layoutProps, /*#__PURE__*/React.createElement(ProgressContentCon, {
    $height: sanitizeThemeStyleByNumber(progressContentConHeight),
    className: "mr-progress-bar-con__content"
  }, milestones.map(function (item, idx) {
    return /*#__PURE__*/React.createElement(IconMilestone, {
      key: idx,
      item: item,
      idx: idx,
      _getLayoutBasedMilestoneProps: getLayoutBasedMilestoneProps
    });
  }))));
};

var MarkerMilestone = function MarkerMilestone(_ref) {
  var _getLayoutBasedMilestoneProps = _ref._getLayoutBasedMilestoneProps,
      idx = _ref.idx,
      item = _ref.item;

  var _getLayoutBasedMilest = _getLayoutBasedMilestoneProps(),
      isSingleMilestone = _getLayoutBasedMilest.isSingleMilestone,
      marks = _getLayoutBasedMilest.marks,
      progressContentWidth = _getLayoutBasedMilest.progressContentWidth,
      milestoneValueColor = _getLayoutBasedMilest.milestoneValueColor,
      milestoneValueFontSize = _getLayoutBasedMilest.milestoneValueFontSize,
      milestoneValueMobileFontSize = _getLayoutBasedMilest.milestoneValueMobileFontSize,
      milestoneValueFontWeight = _getLayoutBasedMilest.milestoneValueFontWeight,
      milestoneValueFontStyle = _getLayoutBasedMilest.milestoneValueFontStyle,
      milestoneValueTextDecoration = _getLayoutBasedMilest.milestoneValueTextDecoration,
      milestoneValueFontFamily = _getLayoutBasedMilest.milestoneValueFontFamily,
      milestoneValueTextAlignment = _getLayoutBasedMilest.milestoneValueTextAlignment,
      milestoneValuePadding = _getLayoutBasedMilest.milestoneValuePadding,
      milestoneValueMargin = _getLayoutBasedMilest.milestoneValueMargin,
      isShowMilestones = _getLayoutBasedMilest.isShowMilestones,
      isShowMilestoneText = _getLayoutBasedMilest.isShowMilestoneText,
      milestoneTextColor = _getLayoutBasedMilest.milestoneTextColor,
      milestoneFontSize = _getLayoutBasedMilest.milestoneFontSize,
      milestoneMobileFontSize = _getLayoutBasedMilest.milestoneMobileFontSize,
      milestoneFontWeight = _getLayoutBasedMilest.milestoneFontWeight,
      milestoneFontStyle = _getLayoutBasedMilest.milestoneFontStyle,
      milestoneTextDecoration = _getLayoutBasedMilest.milestoneTextDecoration,
      milestoneFontFamily = _getLayoutBasedMilest.milestoneFontFamily,
      milestoneTextAlignment = _getLayoutBasedMilest.milestoneTextAlignment,
      milestonePadding = _getLayoutBasedMilest.milestonePadding,
      milestoneMargin = _getLayoutBasedMilest.milestoneMargin,
      max = _getLayoutBasedMilest.max,
      progressBarHeight = _getLayoutBasedMilest.progressBarHeight,
      progressBarMarkerColor = _getLayoutBasedMilest.progressBarMarkerColor;

  return /*#__PURE__*/React.createElement(ProgressContent, {
    key: idx,
    className: "mr-progress-bar-con__item",
    ai: "center",
    flexDir: "column",
    directionValue: isSingleMilestone ? "".concat(100 - SINGLE_MILESTONE_WIDTH, "%") : "".concat(marks[idx].value * 100 / max, "%"),
    $width: progressContentWidth
  }, /*#__PURE__*/React.createElement(ProgressContentText, {
    $color: milestoneValueColor,
    $fontSize: milestoneValueFontSize,
    $mobileFontSize: milestoneValueMobileFontSize,
    $fontWeight: milestoneValueFontWeight,
    $fontStyle: milestoneValueFontStyle,
    $textDecoration: milestoneValueTextDecoration,
    $fontFamily: milestoneValueFontFamily,
    $textAlignment: milestoneValueTextAlignment,
    $padding: milestoneValuePadding,
    $margin: milestoneValueMargin,
    isHidden: !isShowMilestones,
    className: "mr-progress-bar-item__milestone",
    $textWrap: "nowrap",
    $whiteSpace: "nowrap"
  }, item.minText), /*#__PURE__*/React.createElement(Line, {
    $color: progressBarMarkerColor,
    isHidden: !isShowMilestones && !isShowMilestoneText,
    $height: "".concat(parseInt(progressBarHeight, 10) + cssVariables.cvbMarkerTotalExtrusion, "px"),
    className: "mr-progress-bar-item__marker"
  }), isShowMilestoneText && /*#__PURE__*/React.createElement(ProgressContentText, {
    $color: milestoneTextColor,
    $fontSize: milestoneFontSize,
    $mobileFontSize: milestoneMobileFontSize,
    $fontWeight: milestoneFontWeight,
    $fontStyle: milestoneFontStyle,
    $textDecoration: milestoneTextDecoration,
    $fontFamily: milestoneFontFamily,
    $textAlignment: milestoneTextAlignment,
    $padding: milestonePadding,
    $margin: milestoneMargin,
    className: "mr-progress-bar-item__reward",
    $textWrap: "wrap",
    $whiteSpace: "normal"
  }, item.milestoneText));
};

var CVBMarkerLayout = function CVBMarkerLayout(_ref) {
  var layoutProps = _ref.layoutProps,
      milestones = _ref.milestones,
      progressContentConHeight = _ref.progressContentConHeight,
      getLayoutBasedMilestoneProps = _ref.getLayoutBasedMilestoneProps;
  return /*#__PURE__*/React.createElement(ProgressWidget, {
    $fontFamily: layoutProps.font,
    $backgroundColor: layoutProps.offerBackgroundColor,
    isBordered: layoutProps.isOfferBordered,
    $borderColor: layoutProps.offerBorderColor,
    $borderWidth: layoutProps.offerBorderWidth,
    $borderRadius: layoutProps.offerBorderRadius,
    $padding: layoutProps.offerPadding,
    $mobilePadding: layoutProps.offerMobilePadding,
    $margin: layoutProps.offerMargin,
    $mobileMargin: layoutProps.offerMobileMargin,
    className: "mr-embedded-widget mr-embedded-widget--cvb mr-embedded-widget--marker"
  }, /*#__PURE__*/React.createElement(CVBCon, layoutProps, /*#__PURE__*/React.createElement(ProgressContentCon, {
    $height: sanitizeThemeStyleByNumber(progressContentConHeight),
    className: "mr-progress-bar-con__content"
  }, milestones.map(function (item, idx) {
    return /*#__PURE__*/React.createElement(MarkerMilestone, {
      key: idx,
      item: item,
      idx: idx,
      _getLayoutBasedMilestoneProps: getLayoutBasedMilestoneProps
    });
  }))));
};

function round(val) {
  return parseFloat(val).toFixed(2).replace(/\.0+$/, '');
}
function roundTo2(val) {
  var m = Number((Math.abs(val) * 100).toPrecision(15));
  return Math.round(m) / 100 * Math.sign(val);
}
function roundTo2String(val) {
  return round(val);
}

function formatWithSymbolAndSeparator(_ref) {
  var val = _ref.val,
      decimalSymbol = _ref.decimalSymbol,
      thousandSeparator = _ref.thousandSeparator;
  var parts = round(val).toString().split('.');
  var numberPart = parts[0];
  var decimalPart = parts.length > 0 ? parts[1] : undefined;
  var thousands = /\B(?=(\d{3})+(?!\d))/g;
  var formatted = "".concat(numberPart.replace(thousands, thousandSeparator)).concat(decimalPart ? "".concat(decimalSymbol).concat(decimalPart) : '');
  return formatted;
}

function getAmountDisplay(_ref3) {
  var currencyFormat = _ref3.currencyFormat,
      currencySymbol = _ref3.currencySymbol,
      amount = _ref3.amount,
      decimalSymbol = _ref3.decimalSymbol,
      thousandSeparator = _ref3.thousandSeparator;
  return currencyFormat.replace('{{amount}}', formatWithSymbolAndSeparator({
    val: roundTo2String(amount),
    decimalSymbol: decimalSymbol,
    thousandSeparator: thousandSeparator
  })).replace('{{currencySymbol}}', currencySymbol);
}

var TilesMilestone = function TilesMilestone(_ref) {
  var _getLayoutBasedMilestoneProps = _ref._getLayoutBasedMilestoneProps,
      item = _ref.item,
      eachMileStoneWidth = _ref.eachMileStoneWidth,
      progressBarPercentage = _ref.progressBarPercentage,
      progressBarColor = _ref.progressBarColor,
      progressBarActiveColor = _ref.progressBarActiveColor;

  var _getLayoutBasedMilest = _getLayoutBasedMilestoneProps(),
      isSingleMilestone = _getLayoutBasedMilest.isSingleMilestone,
      isShowMilestoneText = _getLayoutBasedMilest.isShowMilestoneText,
      milestoneTextColor = _getLayoutBasedMilest.milestoneTextColor,
      milestoneFontSize = _getLayoutBasedMilest.milestoneFontSize,
      milestoneMobileFontSize = _getLayoutBasedMilest.milestoneMobileFontSize,
      milestoneFontWeight = _getLayoutBasedMilest.milestoneFontWeight,
      milestoneFontStyle = _getLayoutBasedMilest.milestoneFontStyle,
      milestoneTextDecoration = _getLayoutBasedMilest.milestoneTextDecoration,
      milestoneFontFamily = _getLayoutBasedMilest.milestoneFontFamily,
      milestoneTextAlignment = _getLayoutBasedMilest.milestoneTextAlignment,
      milestonePadding = _getLayoutBasedMilest.milestonePadding,
      milestoneMargin = _getLayoutBasedMilest.milestoneMargin;

  return /*#__PURE__*/React.createElement(TilesMilestoneContainer, {
    $width: "".concat(eachMileStoneWidth, "%")
  }, /*#__PURE__*/React.createElement(TilesMilestoneProgressbarWrapper, {
    $backgroundColor: progressBarColor
  }, /*#__PURE__*/React.createElement(TilesMileStoneProgressbar, {
    $width: "".concat(progressBarPercentage, "%") // Apply a width transition with a default duration of 1s and ease-out timing.
    // If the progress bar reaches 100%, 0%, or if it's a single milestone, the transition is set to '0s' for instant width change.
    // Otherwise, the transition lasts for 1s so that next milestone start prgressing, after previous milestone is progressed 100%.
    ,
    $transition: "width 1s ease-out ".concat(progressBarPercentage == 100 || progressBarPercentage == 0 || isSingleMilestone ? '0s' : '1s'),
    $backgroundColor: progressBarActiveColor
  })), isShowMilestoneText && !isSingleMilestone && /*#__PURE__*/React.createElement(ProgressContentText, {
    $color: milestoneTextColor,
    $fontSize: milestoneFontSize,
    $mobileFontSize: milestoneMobileFontSize,
    $fontWeight: milestoneFontWeight,
    $fontStyle: milestoneFontStyle,
    $textDecoration: milestoneTextDecoration,
    $fontFamily: milestoneFontFamily,
    $textAlignment: milestoneTextAlignment,
    $padding: milestonePadding,
    $margin: milestoneMargin,
    className: "mr-progress-bar-item__reward",
    $textWrap: "wrap",
    $whiteSpace: "normal"
  }, item.milestoneText));
};

var TilesLayout = function TilesLayout(_ref) {
  var layoutProps = _ref.layoutProps,
      milestones = _ref.milestones,
      getLayoutBasedMilestoneProps = _ref.getLayoutBasedMilestoneProps;

  var getProgressBarPercentageForMileStone = function getProgressBarPercentageForMileStone(idx) {
    var _milestones$idx;

    var width = +layoutProps.cartAmount / +((_milestones$idx = milestones[idx]) === null || _milestones$idx === void 0 ? void 0 : _milestones$idx.minValue) * 100;

    if (idx !== 0) {
      var _milestones;

      // from second milestone check if previous milstone achived then return calculated width else return 0
      if (+layoutProps.cartAmount > +((_milestones = milestones[idx - 1]) === null || _milestones === void 0 ? void 0 : _milestones.minValue)) {
        var _milestones2, _milestones$idx2, _milestones3;

        // width = cart_amount - previous_milestone_value / current_milestone_value - previous_milestone_value
        width = (+layoutProps.cartAmount - +((_milestones2 = milestones[idx - 1]) === null || _milestones2 === void 0 ? void 0 : _milestones2.minValue)) / (+((_milestones$idx2 = milestones[idx]) === null || _milestones$idx2 === void 0 ? void 0 : _milestones$idx2.minValue) - +((_milestones3 = milestones[idx - 1]) === null || _milestones3 === void 0 ? void 0 : _milestones3.minValue)) * 100;
        return width > 100 ? 100 : width;
      }

      return 0;
    }

    return width > 100 ? 100 : width;
  }; // each milestone should have equal width


  var eachMileStoneWidth = 100 / milestones.length;
  return /*#__PURE__*/React.createElement(ProgressWidget, {
    $fontFamily: layoutProps.font,
    $backgroundColor: layoutProps.offerBackgroundColor,
    isBordered: layoutProps.isOfferBordered,
    $borderColor: layoutProps.offerBorderColor,
    $borderWidth: layoutProps.offerBorderWidth,
    $borderRadius: layoutProps.offerBorderRadius,
    $padding: layoutProps.offerPadding,
    $mobilePadding: layoutProps.offerMobilePadding,
    $margin: layoutProps.offerMargin,
    $mobileMargin: layoutProps.offerMobileMargin,
    className: "mr-embedded-widget mr-embedded-widget--cvb mr-embedded-widget--marker"
  }, /*#__PURE__*/React.createElement(CVBCon, layoutProps, /*#__PURE__*/React.createElement(TilesMilestonesWrapper, null, milestones.map(function (mileStone, index) {
    return /*#__PURE__*/React.createElement(TilesMilestone, {
      key: index,
      _getLayoutBasedMilestoneProps: getLayoutBasedMilestoneProps,
      idx: index,
      item: mileStone,
      eachMileStoneWidth: eachMileStoneWidth,
      progressBarPercentage: getProgressBarPercentageForMileStone(index),
      progressBarColor: layoutProps.progressBarColor,
      progressBarActiveColor: layoutProps.progressBarActiveColor
    });
  }))));
};

var CVB = function CVB(props) {
  var currencyFormat = props.currencyFormat,
      currencySymbol = props.currencySymbol,
      _props$decimalSymbol = props.decimalSymbol,
      decimalSymbol = _props$decimalSymbol === void 0 ? '.' : _props$decimalSymbol,
      _props$thousandSepara = props.thousandSeparator,
      thousandSeparator = _props$thousandSepara === void 0 ? '' : _props$thousandSepara,
      milestones = props.milestones,
      cartAmount = props.cartAmount,
      isMobile = props.isMobile,
      isShowHeader = props.isShowHeader,
      isShowMilestoneText = props.isShowMilestoneText,
      isShowMilestones = props.isShowMilestones,
      offerPadding = props.offerPadding,
      offerMobilePadding = props.offerMobilePadding,
      offerMargin = props.offerMargin,
      offerMobileMargin = props.offerMobileMargin,
      isOfferBordered = props.isOfferBordered,
      offerBorderRadius = props.offerBorderRadius,
      offerBorderColor = props.offerBorderColor,
      offerBorderWidth = props.offerBorderWidth,
      offerBackgroundColor = props.offerBackgroundColor,
      offerHeaderBarBackgroundColor = props.offerHeaderBarBackgroundColor,
      offerHeaderBarPadding = props.offerHeaderBarPadding,
      offerHeaderBarMargin = props.offerHeaderBarMargin,
      offerHeaderText = props.offerHeaderText,
      offerHeaderSuccessText = props.offerHeaderSuccessText,
      offerHeaderTextColor = props.offerHeaderTextColor,
      offerHeaderFontSize = props.offerHeaderFontSize,
      offerHeaderMobileFontSize = props.offerHeaderMobileFontSize,
      offerHeaderFontWeight = props.offerHeaderFontWeight,
      offerHeaderFontStyle = props.offerHeaderFontStyle,
      offerHeaderTextDecoration = props.offerHeaderTextDecoration,
      offerHeaderFontFamily = props.offerHeaderFontFamily,
      offerHeaderTextAlignment = props.offerHeaderTextAlignment,
      offerHeaderSuccessTextColor = props.offerHeaderSuccessTextColor,
      offerHeaderSuccessFontSize = props.offerHeaderSuccessFontSize,
      offerHeaderSuccessMobileFontSize = props.offerHeaderSuccessMobileFontSize,
      offerHeaderSuccessFontWeight = props.offerHeaderSuccessFontWeight,
      offerHeaderSuccessFontStyle = props.offerHeaderSuccessFontStyle,
      offerHeaderSuccessTextDecoration = props.offerHeaderSuccessTextDecoration,
      offerHeaderSuccessFontFamily = props.offerHeaderSuccessFontFamily,
      offerHeaderSuccessTextAlignment = props.offerHeaderSuccessTextAlignment,
      progressBarHeight = props.progressBarHeight,
      progressBarColor = props.progressBarColor,
      progressBarActiveColor = props.progressBarActiveColor,
      progressBarMarkerColor = props.progressBarMarkerColor,
      progressBarBorderRadius = props.progressBarBorderRadius,
      milestoneValueColor = props.milestoneValueColor,
      milestoneValueMobileFontSize = props.milestoneValueMobileFontSize,
      milestoneValueFontStyle = props.milestoneValueFontStyle,
      milestoneValueFontWeight = props.milestoneValueFontWeight,
      milestoneValueTextDecoration = props.milestoneValueTextDecoration,
      milestoneValueFontFamily = props.milestoneValueFontFamily,
      milestoneValueTextAlignment = props.milestoneValueTextAlignment,
      milestoneValuePadding = props.milestoneValuePadding,
      milestoneValueMargin = props.milestoneValueMargin,
      milestoneTextColor = props.milestoneTextColor,
      milestoneMobileFontSize = props.milestoneMobileFontSize,
      milestoneFontWeight = props.milestoneFontWeight,
      milestoneFontStyle = props.milestoneFontStyle,
      milestoneTextDecoration = props.milestoneTextDecoration,
      milestoneFontFamily = props.milestoneFontFamily,
      milestoneTextAlignment = props.milestoneTextAlignment,
      milestonePadding = props.milestonePadding,
      milestoneMargin = props.milestoneMargin,
      progressBarContainerPadding = props.progressBarContainerPadding,
      progressBarContainerMargin = props.progressBarContainerMargin,
      remainingAmountRoundType = props.remainingAmountRoundType,
      mobileLayoutType = props.mobileLayoutType,
      desktopLayoutType = props.desktopLayoutType,
      iconMobileSize = props.iconMobileSize,
      iconDesktopSize = props.iconDesktopSize,
      iconMobileBorderSize = props.iconMobileBorderSize,
      iconDesktopBorderSize = props.iconDesktopBorderSize,
      iconBorderColor = props.iconBorderColor,
      iconBorderRadius = props.iconBorderRadius,
      iconBackgroundColor = props.iconBackgroundColor,
      font = props.font,
      cvbTileTitleText = props.cvbTileTitleText,
      cvbTileTitleTextColor = props.cvbTileTitleTextColor,
      cvbTileTitleTextAlignment = props.cvbTileTitleTextAlignment,
      cvbTileTitleFontFamily = props.cvbTileTitleFontFamily,
      cvbTileTitleFontSize = props.cvbTileTitleFontSize,
      cvbTileTitleMargin = props.cvbTileTitleMargin,
      cvbTileTitlePadding = props.cvbTileTitlePadding;
  var milestoneValueFontSize = props.milestoneValueFontSize,
      milestoneFontSize = props.milestoneFontSize;

  if (isMobile) {
    milestoneValueFontSize = milestoneValueMobileFontSize;
    milestoneFontSize = milestoneMobileFontSize;
  }

  var isMobileIconLayoutType = isMobile && mobileLayoutType === 'icon';
  var isDesktopIconLayoutType = !isMobile && desktopLayoutType === 'icon';
  var isMobileMarkerLayoutType = isMobile && mobileLayoutType === 'marker';
  var isDesktopMarkerLayoutType = !isMobile && desktopLayoutType === 'marker';
  var isMobileTilesLayoutType = isMobile && mobileLayoutType === 'tiles';
  var isDesktopTilesLayoutType = !isMobile && desktopLayoutType === 'tiles';
  var isMarkerLayoutType = isMobileMarkerLayoutType || isDesktopMarkerLayoutType;
  var isIconLayoutType = isMobileIconLayoutType || isDesktopIconLayoutType;
  var isTilesLayoutType = isMobileTilesLayoutType || isDesktopTilesLayoutType;
  var isSingleMilestone = milestones.length === 1;

  var initMarks = function initMarks(data) {
    return data.reduce(function (marks, curr, idx) {
      return marks.concat({
        value: idx,
        scaledValue: curr.minValue
      });
    }, []);
  };

  var marks = initMarks(milestones);
  var max = milestones.length;

  var shrink = function shrink(val) {
    var min = marks[0].scaledValue;
    var markerWidth = 1 / max;

    if (val < min) {
      return val / min * (markerWidth - markerWidth / 2);
    }

    if (val >= marks[marks.length - 1].scaledValue) {
      return 1;
    }

    var idx = 0;

    for (var i = 0; i < marks.length; i += 1) {
      idx = i;

      if (val < marks[i].scaledValue) {
        break;
      }
    }

    var higherVal = marks[idx].scaledValue;
    var prevVal = idx < 1 ? 0 : marks[idx - 1].scaledValue;
    var inter = (val - prevVal) / (higherVal - prevVal);
    var increment = idx / max - markerWidth / 2;
    inter *= markerWidth;
    return inter + increment;
  };

  var areAllMilestonesAchieved = function areAllMilestonesAchieved() {
    var minValue = milestones[milestones.length - 1].minValue;
    return cartAmount >= minValue;
  };

  var showTilesTitleHeader = function showTilesTitleHeader() {
    var minValue = milestones[0].minValue;
    return cartAmount >= minValue;
  };

  var getHeaderTextWithVariablesReplaced = function getHeaderTextWithVariablesReplaced(text) {
    var useText = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var nextMilestone = milestones[0];

    for (var i = 0; i < milestones.length; i++) {
      if (milestones[i].minValue > cartAmount) {
        nextMilestone = milestones[i];
        break;
      }
    }

    var _nextMilestone = nextMilestone,
        minValue = _nextMilestone.minValue,
        milestoneText = _nextMilestone.milestoneText,
        milestoneHeaderText = _nextMilestone.milestoneHeaderText,
        valueType = _nextMilestone.valueType;
    var amt = roundTo2(minValue - cartAmount);

    if (remainingAmountRoundType == 'down') {
      amt = Math.floor(minValue - cartAmount);
    }

    var amountLeft = amt;

    if (valueType === 'price') {
      amountLeft = getAmountDisplay({
        currencyFormat: currencyFormat,
        currencySymbol: currencySymbol,
        amount: amt,
        thousandSeparator: thousandSeparator,
        decimalSymbol: decimalSymbol
      });
    }

    var textToUse = milestoneHeaderText;
    if (useText) textToUse = text;
    return textToUse.replace('{{amount_left}}', amountLeft).replace('{{item_left}}', amountLeft).replace('{{latest_reward}}', milestoneText);
  };

  var infoAmt = '';
  var cartValue = shrink(cartAmount); // in case its a single milestone and it is not reached, then we have to compute the active
  // width as the milestone is custom postioned.
  // formula ->
  // the center of the milestone is our maximum available width to reach the milestone
  // so we get that by (100 - (milestoneWidth / 2))
  // then we divide that by the milestone value to get the width per unit
  // to get the width for the current cart value, we multiply the width per unit by the cart value
  // as the width is passed on a scale of 0-1 we divide it by 100

  if (isSingleMilestone && cartAmount < marks[0].scaledValue) {
    cartValue = (100 - SINGLE_MILESTONE_WIDTH / 2) / marks[0].scaledValue * cartAmount;
    cartValue = cartValue / 100;
  }

  var finalMilestoneReached = areAllMilestonesAchieved();
  var headerText = finalMilestoneReached ? offerHeaderSuccessText.replace('{{latest_reward}}', milestones[milestones.length - 1].milestoneText) : getHeaderTextWithVariablesReplaced(offerHeaderText);
  var headerTextColor = finalMilestoneReached ? offerHeaderSuccessTextColor : offerHeaderTextColor;
  var headerFontSize = finalMilestoneReached ? offerHeaderSuccessFontSize : offerHeaderFontSize;
  var headerMobileFontSize = finalMilestoneReached ? offerHeaderSuccessMobileFontSize : offerHeaderMobileFontSize;
  var cvbHeaderFontSize = isMobile ? headerMobileFontSize : headerFontSize;
  var headerFontWeight = finalMilestoneReached ? offerHeaderSuccessFontWeight : offerHeaderFontWeight;
  var headerFontStyle = finalMilestoneReached ? offerHeaderSuccessFontStyle : offerHeaderFontStyle;
  var headerTextDecoration = finalMilestoneReached ? offerHeaderSuccessTextDecoration : offerHeaderTextDecoration;
  var headerFontFamily = finalMilestoneReached ? offerHeaderSuccessFontFamily : offerHeaderFontFamily;
  var headerTextAlignment = finalMilestoneReached ? offerHeaderSuccessTextAlignment : offerHeaderTextAlignment;
  var progressBarContainerPaddingArr = getSeparatedStyleValueArr(progressBarContainerPadding);
  var milestoneValueMarginArr = getSeparatedStyleValueArr(milestoneValueMargin);
  var milestoneMarginArr = getSeparatedStyleValueArr(milestoneMargin);
  var progressBarWidth = "calc(100% - ".concat(progressBarContainerPaddingArr[1] + progressBarContainerPaddingArr[3], "px)");
  var iconSizeToUse = +(isMobile ? iconMobileSize : iconDesktopSize);
  var markerAdjustmentForPBTop = isMarkerLayoutType ? cssVariables.cvbMarkerTotalExtrusion / 2 : 0;
  var iconAdjustmentForPBTop = isIconLayoutType ? iconSizeToUse / 2 - // icon adjustment
  progressBarHeight / 2 : 0;
  var progressBarTopPlacement = progressBarContainerPaddingArr[0] + // progressBarContainer paddingTop
  milestoneValueMarginArr[0] + // milestoneValueText marginTop
  milestoneValueMarginArr[2] + // milestoneValueText marginBottom
  Number(milestoneValueFontSize) * cssVariables.lineHeight + // milestoneValueText fontSize * lineHeight to get text height
  markerAdjustmentForPBTop + iconAdjustmentForPBTop; // marker adjustment

  var markerAdjustmentForPCCTop = isMarkerLayoutType ? cssVariables.cvbMarkerTotalExtrusion : 0;
  var iconAdjustmentForPCCTop = isIconLayoutType ? iconSizeToUse : 0;
  var progressContentConHeight = milestoneValueMarginArr[0] + // milestoneValueText marginTop
  milestoneValueMarginArr[2] + // milestoneValueText marginBottom
  milestoneMarginArr[0] + // milestoneText marginTop
  milestoneMarginArr[2] + // milestoneText marginBottom
  parseInt(progressBarHeight, 10) + Number(milestoneValueFontSize) * cssVariables.lineHeight + // milestoneValueText fontSize * lineHeight to get text height
  Number(milestoneFontSize) * cssVariables.lineHeight + markerAdjustmentForPCCTop + // milestoneText fontSize * lineHeight to get text height
  iconAdjustmentForPCCTop; // marker adjustment

  var progressContentWidth = isSingleMilestone ? "".concat(SINGLE_MILESTONE_WIDTH, "%") : "".concat(100 / milestones.length, "%");

  var getLayoutBasedMilestoneProps = function getLayoutBasedMilestoneProps() {
    return {
      isSingleMilestone: isSingleMilestone,
      marks: marks,
      progressContentWidth: progressContentWidth,
      milestoneValueColor: milestoneValueColor,
      milestoneValueFontSize: milestoneValueFontSize,
      milestoneValueMobileFontSize: milestoneValueMobileFontSize,
      milestoneValueFontWeight: milestoneValueFontWeight,
      milestoneValueFontStyle: milestoneValueFontStyle,
      milestoneValueTextDecoration: milestoneValueTextDecoration,
      milestoneValueFontFamily: milestoneValueFontFamily,
      milestoneValueTextAlignment: milestoneValueTextAlignment,
      milestoneValuePadding: milestoneValuePadding,
      milestoneValueMargin: milestoneValueMargin,
      isShowMilestones: isShowMilestones,
      isMobile: isMobile,
      isShowMilestoneText: isShowMilestoneText,
      milestoneTextColor: milestoneTextColor,
      milestoneFontSize: milestoneFontSize,
      milestoneMobileFontSize: milestoneMobileFontSize,
      milestoneFontWeight: milestoneFontWeight,
      milestoneFontStyle: milestoneFontStyle,
      milestoneTextDecoration: milestoneTextDecoration,
      milestoneFontFamily: milestoneFontFamily,
      milestoneTextAlignment: milestoneTextAlignment,
      milestonePadding: milestonePadding,
      milestoneMargin: milestoneMargin,
      iconMobileSize: iconMobileSize,
      iconDesktopSize: iconDesktopSize,
      iconMobileBorderSize: iconMobileBorderSize,
      iconDesktopBorderSize: iconDesktopBorderSize,
      iconBorderColor: iconBorderColor,
      iconBorderRadius: iconBorderRadius,
      max: max,
      progressBarMarkerColor: progressBarMarkerColor,
      progressBarHeight: progressBarHeight,
      iconBackgroundColor: iconBackgroundColor
    };
  };

  var layoutProps = {
    isOfferBordered: isOfferBordered,
    font: font,
    offerBackgroundColor: offerBackgroundColor,
    offerBorderColor: offerBorderColor,
    offerBorderWidth: offerBorderWidth,
    offerBorderRadius: offerBorderRadius,
    offerPadding: offerPadding,
    offerMobilePadding: offerMobilePadding,
    offerMargin: offerMargin,
    offerMobileMargin: offerMobileMargin,
    isShowHeader: isShowHeader,
    offerHeaderBarBackgroundColor: offerHeaderBarBackgroundColor,
    offerHeaderBarPadding: offerHeaderBarPadding,
    offerHeaderBarMargin: offerHeaderBarMargin,
    headerTextColor: headerTextColor,
    headerFontSize: headerFontSize,
    headerMobileFontSize: headerMobileFontSize,
    headerFontWeight: headerFontWeight,
    headerFontStyle: headerFontStyle,
    headerTextDecoration: headerTextDecoration,
    headerFontFamily: headerFontFamily,
    headerTextAlignment: headerTextAlignment,
    progressBarContainerMargin: progressBarContainerMargin,
    progressBarContainerPadding: progressBarContainerPadding,
    progressBarTopPlacement: progressBarTopPlacement,
    progressBarWidth: progressBarWidth,
    progressBarHeight: progressBarHeight,
    progressBarColor: progressBarColor,
    progressBarBorderRadius: progressBarBorderRadius,
    progressBarActiveColor: progressBarActiveColor,
    cartValue: cartValue,
    headerText: headerText,
    infoAmt: infoAmt,
    cvbHeaderFontSize: cvbHeaderFontSize,
    cvbTileTitleText: cvbTileTitleText,
    cvbTileTitleTextColor: cvbTileTitleTextColor,
    cvbTileTitleTextAlignment: cvbTileTitleTextAlignment,
    cvbTileTitleFontFamily: cvbTileTitleFontFamily,
    cvbTileTitleFontSize: cvbTileTitleFontSize,
    cvbTileTitleMargin: cvbTileTitleMargin,
    cvbTileTitlePadding: cvbTileTitlePadding,
    showTilesTitleHeader: showTilesTitleHeader,
    cartAmount: cartAmount,
    isTilesLayoutType: isTilesLayoutType
  };
  var commonProps = {
    layoutProps: layoutProps,
    getLayoutBasedMilestoneProps: getLayoutBasedMilestoneProps,
    milestones: milestones,
    progressContentConHeight: progressContentConHeight
  };
  if (isIconLayoutType) return /*#__PURE__*/React.createElement(CVBIconLayout, commonProps);
  if (isMarkerLayoutType) return /*#__PURE__*/React.createElement(CVBMarkerLayout, commonProps);
  if (isTilesLayoutType) return /*#__PURE__*/React.createElement(TilesLayout, commonProps);
};

CVB.propTypes = {
  isMobile: PropTypes.bool,
  currencyFormat: PropTypes.string,
  currencySymbol: PropTypes.string,
  offerPadding: PropTypes.string,
  offerMobilePadding: PropTypes.string,
  offerMargin: PropTypes.string,
  offerMobileMargin: PropTypes.string,
  isOfferBordered: PropTypes.bool,
  offerBorderColor: PropTypes.string,
  offerBorderRadius: PropTypes.string,
  offerBorderWidth: PropTypes.string,
  offerBackgroundColor: PropTypes.string,
  cartAmount: PropTypes.number,
  milestones: PropTypes.array,
  isShowHeader: PropTypes.bool,
  isShowMilestoneText: PropTypes.bool,
  isShowMilestones: PropTypes.bool,
  offerHeaderBarBackgroundColor: PropTypes.string,
  offerHeaderBarPadding: PropTypes.string,
  offerHeaderBarMargin: PropTypes.string,
  offerHeaderText: PropTypes.string,
  offerHeaderTextColor: PropTypes.string,
  offerHeaderFontSize: PropTypes.string,
  offerHeaderMobileFontSize: PropTypes.string,
  offerHeaderFontWeight: PropTypes.string,
  offerHeaderFontStyle: PropTypes.string,
  offerHeaderTextDecoration: PropTypes.string,
  offerHeaderFontFamily: PropTypes.string,
  offerHeaderTextAlignment: PropTypes.string,
  offerHeaderSuccessText: PropTypes.string,
  offerHeaderSuccessTextColor: PropTypes.string,
  offerHeaderSuccessFontSize: PropTypes.string,
  offerHeaderSuccessMobileFontSize: PropTypes.string,
  offerHeaderSuccessFontWeight: PropTypes.string,
  offerHeaderSuccessFontStyle: PropTypes.string,
  offerHeaderSuccessTextDecoration: PropTypes.string,
  offerHeaderSuccessFontFamily: PropTypes.string,
  offerHeaderSuccessTextAlignment: PropTypes.string,
  progressBarHeight: PropTypes.string,
  progressBarColor: PropTypes.string,
  progressBarActiveColor: PropTypes.string,
  progressBarMarkerColor: PropTypes.string,
  progressBarBorderRadius: PropTypes.string,
  milestoneValueColor: PropTypes.string,
  milestoneValueFontSize: PropTypes.string,
  milestoneValueMobileFontSize: PropTypes.string,
  milestoneValueFontStyle: PropTypes.string,
  milestoneValueFontWeight: PropTypes.string,
  milestoneValueTextDecoration: PropTypes.string,
  milestoneValueFontFamily: PropTypes.string,
  milestoneValueTextAlignment: PropTypes.string,
  milestoneValuePadding: PropTypes.string,
  milestoneValueMargin: PropTypes.string,
  milestoneTextColor: PropTypes.string,
  milestoneFontSize: PropTypes.string,
  milestoneMobileFontSize: PropTypes.string,
  milestoneFontWeight: PropTypes.string,
  milestoneFontStyle: PropTypes.string,
  milestoneTextDecoration: PropTypes.string,
  milestoneFontFamily: PropTypes.string,
  milestoneTextAlignment: PropTypes.string,
  milestonePadding: PropTypes.string,
  milestoneMargin: PropTypes.string,
  progressBarContainerPadding: PropTypes.string,
  progressBarContainerMargin: PropTypes.string,
  remainingAmountRoundType: PropTypes.string,
  font: PropTypes.string,
  mobileLayoutType: PropTypes.string,
  desktopLayoutType: PropTypes.string,
  iconMobileSize: PropTypes.string,
  iconDesktopSize: PropTypes.string,
  iconMobileBorderSize: PropTypes.string,
  iconDesktopBorderSize: PropTypes.string,
  iconBorderColor: PropTypes.string,
  iconBorderRadius: PropTypes.string,
  iconBackgroundColor: PropTypes.string,
  decimalSymbol: PropTypes.string,
  thousandSeparator: PropTypes.string,
  cvbTileTitleText: PropTypes.string,
  cvbTileTitleTextColor: PropTypes.string,
  cvbTileTitleTextAlignment: PropTypes.string,
  cvbTileTitleFontFamily: PropTypes.string,
  cvbTileTitleFontSize: PropTypes.string,
  cvbTileTitleMargin: PropTypes.string,
  cvbTileTitlePadding: PropTypes.string
};

var _templateObject$3;
var CustomImg = styled.img(_templateObject$3 || (_templateObject$3 = _taggedTemplateLiteral(["\n  width: ", "px;\n  height: ", "px;\n  border-radius: ", "px;\n"])), function (_ref) {
  var width = _ref.width;
  return width;
}, function (_ref2) {
  var height = _ref2.height;
  return height;
}, function (_ref3) {
  var radius = _ref3.radius;
  return radius;
});

var SPImgCon = function SPImgCon(_ref4) {
  var src = _ref4.src,
      styles = _ref4.styles,
      className = _ref4.className;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(CustomImg, _extends({
    className: className,
    src: src
  }, styles)));
};
SPImgCon.propTypes = {
  src: PropTypes.any,
  styles: PropTypes.object,
  className: PropTypes.string
};

var _templateObject$2, _templateObject2$2;
var Toggle = styled.button(_templateObject$2 || (_templateObject$2 = _taggedTemplateLiteral(["\n border: 1.5px solid black;\n width: 31px;\n height: 16.5px;\n border-radius: 100px;\n display: flex;\n align-items: center;\n padding: 1px;\n cursor: pointer;\n"])));
var InnerCircle = styled.div(_templateObject2$2 || (_templateObject2$2 = _taggedTemplateLiteral(["\n    border-radius: 100px;\n    width: 12.5px;\n    height: 12.5px;\n    display: flex !important;\n"])));

var ToggleButton = function ToggleButton(_ref) {
  var isToggleOn = _ref.isToggleOn,
      toggleHandler = _ref.toggleHandler,
      className = _ref.className;
  var btnBgOffStyles = {
    backgroundColor: 'white',
    justifyContent: 'flex-start'
  };
  var btnCircleOffStyles = {
    backgroundColor: 'black'
  };
  var btnBgOnStyles = {
    backgroundColor: 'black',
    justifyContent: 'flex-end'
  };
  var btnCircleOnStyles = {
    backgroundColor: 'white',
    justifyContent: 'flex-start'
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Toggle, {
    type: "button",
    className: className,
    style: isToggleOn ? btnBgOnStyles : btnBgOffStyles,
    onClick: toggleHandler
  }, /*#__PURE__*/React.createElement(InnerCircle, {
    style: isToggleOn ? btnCircleOnStyles : btnCircleOffStyles
  })));
};
ToggleButton.propTypes = {
  isToggleOn: PropTypes.bool,
  toggleHandler: PropTypes.func,
  className: PropTypes.string
};

var _templateObject$1, _templateObject2$1, _templateObject3$1, _templateObject4$1, _templateObject5$1, _templateObject6$1;
var Container = styled.div(_templateObject$1 || (_templateObject$1 = _taggedTemplateLiteral(["\n  display: flex;\n  gap: 8px;\n  padding: ", ";\n  margin: ", ";\n  background-color: ", ";\n  font-family: ", ";\n  border-width: ", "px;\n  border-color: ", ";\n  border-style: ", ";\n  justify-content: center;\n  max-width: 420px;\n"])), function (_ref) {
  var padding = _ref.padding;
  return padding;
}, function (_ref2) {
  var margin = _ref2.margin;
  return margin;
}, function (_ref3) {
  var background = _ref3.background;
  return background;
}, function (_ref4) {
  var font = _ref4.font;
  return font;
}, function (_ref5) {
  var borderWidth = _ref5.borderWidth;
  return borderWidth;
}, function (_ref6) {
  var borderColor = _ref6.borderColor;
  return borderColor;
}, function (_ref7) {
  var borderStyle = _ref7.borderStyle;
  return borderStyle;
});
var ContentSection = styled.div(_templateObject2$1 || (_templateObject2$1 = _taggedTemplateLiteral(["\n  font-size: 14px;\n  color: rgba(0, 0, 0, 0.6);\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n"])));
var HeadingSection = styled.div(_templateObject3$1 || (_templateObject3$1 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 7px;\n"])));
var ImgContainer = styled.div(_templateObject4$1 || (_templateObject4$1 = _taggedTemplateLiteral(["\n  padding: ", ";\n  margin: ", ";\n\n  & img {\n    object-fit: contain;\n  }\n"])), function (_ref8) {
  var padding = _ref8.padding;
  return padding;
}, function (_ref9) {
  var margin = _ref9.margin;
  return margin;
});
var Text = styled.div(_templateObject5$1 || (_templateObject5$1 = _taggedTemplateLiteral(["\n  font-size: ", "px;\n  font-family: ", ";\n  padding: ", ";\n  width: ", ";\n  font-weight: ", ";\n  font-style: ", ";\n  color: ", ";\n  text-decoration: ", ";\n  text-align: ", ";\n"])), function (_ref10) {
  var fontSize = _ref10.fontSize;
  return fontSize;
}, function (_ref11) {
  var fontFamily = _ref11.fontFamily;
  return fontFamily;
}, function (_ref12) {
  var padding = _ref12.padding;
  return padding;
}, function (_ref13) {
  var width = _ref13.width;
  return width;
}, function (_ref14) {
  var fontWeight = _ref14.fontWeight;
  return fontWeight;
}, function (_ref15) {
  var fontStyle = _ref15.fontStyle;
  return fontStyle;
}, function (_ref16) {
  var color = _ref16.color;
  return color;
}, function (_ref17) {
  var textDecoration = _ref17.textDecoration;
  return textDecoration;
}, function (_ref18) {
  var textAlignment = _ref18.textAlignment;
  return textAlignment;
});
var RightContainer = styled.div(_templateObject6$1 || (_templateObject6$1 = _taggedTemplateLiteral(["\n  width: 100% !important;\n"])));

var ShippingProtection = function ShippingProtection(_ref19) {
  var theme = _ref19.theme,
      isMobile = _ref19.isMobile,
      imageURL = _ref19.imageURL,
      isToggleOn = _ref19.isToggleOn,
      toggleHandler = _ref19.toggleHandler,
      priceToDisplay = _ref19.priceToDisplay,
      decimalSymbol = _ref19.decimalSymbol,
      thousandSeparator = _ref19.thousandSeparator,
      currencyFormat = _ref19.currencyFormat,
      currencySymbol = _ref19.currencySymbol;

  var _useDynamicImage = useDynamicImage('spLogo'),
      defaultSpImg = _useDynamicImage.image;

  var imgStyles = {
    width: isMobile ? theme.shipProImageMobileWidth : theme.shipProImageWidth,
    height: isMobile ? theme.shipProImageMobileHeight : theme.shipProImageHeight,
    radius: isMobile ? theme.shipProImageMobileRadius : theme.shipProImageRadius
  };
  var imgContainerStyles = {
    padding: isMobile ? theme.shipProImageMobilePadding : theme.shipProImagePadding,
    margin: isMobile ? theme.shipProImageMobileMargin : theme.shipProImageMargin
  };
  var titleTextStyles = {
    fontSize: isMobile ? theme.shipProTitleMobileFontSize : theme.shipProTitleFontSize,
    fontFamily: theme.shipProTitleFontFamily,
    padding: isMobile ? theme.shipProTitleMobilePadding : theme.shipProTitlePadding,
    color: theme.shipProTitleTextColor,
    fontWeight: theme.shipProTitleFontWeight,
    textAlignment: theme.shipProTitleTextAlignment,
    fontStyle: theme.shipProTitleFontStyle,
    textDecoration: theme.shipProTitleTextDecoration,
    width: '100%'
  };
  var subTitleTextStyles = {
    fontSize: isMobile ? theme.shipProSubtitleMobileFontSize : theme.shipProSubtitleFontSize,
    fontFamily: theme.shipProSubtitleFontFamily,
    padding: isMobile ? theme.shipProSubtitleMobilePadding : theme.shipProSubtitlePadding,
    color: theme.shipProSubtitleTextColor,
    fontWeight: theme.shipProSubtitleFontWeight,
    textAlignment: theme.shipProSubtitleTextAlignment,
    fontStyle: theme.shipProSubtitleFontStyle,
    textDecoration: theme.shipProSubtitleTextDecoration
  };
  var descriptionTextStyles = {
    fontSize: isMobile ? theme.shipProDescriptionMobileFontSize : theme.shipProDescriptionFontSize,
    fontFamily: theme.shipProDescriptionFontFamily,
    padding: isMobile ? theme.shipProDescriptionMobilePadding : theme.shipProDescriptionPadding,
    color: theme.shipProDescriptionTextColor,
    fontWeight: theme.shipProDescriptionFontWeight,
    textAlignment: theme.shipProDescriptionTextAlignment,
    fontStyle: theme.shipProDescriptionFontStyle,
    textDecoration: theme.shipProDescriptionTextDecoration
  };
  var containerStyles = {
    padding: isMobile ? theme.widgetMobilePadding : theme.widgetPadding,
    margin: isMobile ? theme.widgetMobileMargin : theme.widgetMargin,
    background: theme.offerBackgroundColor,
    font: theme.font,
    borderWidth: theme.isOfferBordered && theme.offerBorderWidth,
    borderColor: theme.isOfferBordered && theme.offerBorderColor,
    borderStyle: theme.isOfferBordered && 'solid',
    width: '100%'
  };

  var getSubtitleText = function getSubtitleText() {
    var amount = getAmountDisplay({
      currencyFormat: currencyFormat,
      currencySymbol: currencySymbol,
      amount: priceToDisplay,
      decimalSymbol: decimalSymbol,
      thousandSeparator: thousandSeparator
    });
    return theme.shipProSubtitleText.replace('{{amount}}', amount);
  };

  var getDescriptionText = function getDescriptionText() {
    if (isToggleOn) {
      return theme.shipProDescriptionEnabledText;
    }

    return theme.shipProDescriptionDisabledText;
  };

  return /*#__PURE__*/React.createElement(Container, _extends({
    className: "mr-embedded-widget mr-embedded-widget--ship-pro"
  }, containerStyles), /*#__PURE__*/React.createElement(ImgContainer, _extends({}, imgContainerStyles, {
    className: "mr-image__con"
  }), /*#__PURE__*/React.createElement(SPImgCon, {
    className: "mr-image",
    src: imageURL !== '' ? imageURL : defaultSpImg,
    styles: imgStyles
  })), /*#__PURE__*/React.createElement(RightContainer, {
    className: "mr-content__con"
  }, /*#__PURE__*/React.createElement(HeadingSection, {
    className: "mr-heading__con"
  }, /*#__PURE__*/React.createElement(MdText, {
    fontSize: "".concat(titleTextStyles.fontSize, "px"),
    alignment: titleTextStyles.textAlignment,
    color: titleTextStyles.color,
    fontWeight: "",
    fontFamily: titleTextStyles.fontFamily
  }, theme.shipProTitleText), /*#__PURE__*/React.createElement(ToggleButton, {
    className: "mr-heading__toggle-button",
    isToggleOn: isToggleOn,
    toggleHandler: toggleHandler
  })), /*#__PURE__*/React.createElement(ContentSection, {
    className: "mr-text__con"
  }, /*#__PURE__*/React.createElement(MdText, {
    fontSize: "".concat(subTitleTextStyles.fontSize, "px"),
    alignment: subTitleTextStyles.textAlignment,
    color: subTitleTextStyles.color,
    fontWeight: "",
    fontFamily: subTitleTextStyles.fontFamily
  }, getSubtitleText()), /*#__PURE__*/React.createElement(Text, _extends({
    className: "mr-text__description"
  }, descriptionTextStyles), getDescriptionText()))));
};
ShippingProtection.propTypes = {
  theme: PropTypes.object,
  isMobile: PropTypes.bool,
  isToggleOn: PropTypes.bool,
  toggleHandler: PropTypes.func,
  imageURL: PropTypes.any,
  priceToDisplay: PropTypes.any,
  decimalSymbol: PropTypes.string,
  thousandSeparator: PropTypes.string,
  currencyFormat: PropTypes.string,
  currencySymbol: PropTypes.string
};

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;
var ButtonCon = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: relative;\n  width: 100%;\n"])));
var Button = styled.button(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  width: ", ";\n  height: ", "px;\n  border-radius: ", "px;\n  background: ", ";\n  font-family: ", ";\n  font-size: ", "px;\n  padding: ", ";\n  margin: ", ";\n  cursor: pointer;\n\n  display: flex;\n  justify-content: ", ";\n  align-items: center;\n  gap: 0.4rem;\n  color: #ffffff;\n\n  border: none;\n\n  &:disabled {\n    opacity: 0.6;\n  }\n"])), function (_ref) {
  var buttonWidth = _ref.buttonWidth;
  return buttonWidth;
}, function (_ref2) {
  var buttonHeight = _ref2.buttonHeight;
  return buttonHeight;
}, function (_ref3) {
  var buttonRadius = _ref3.buttonRadius;
  return buttonRadius;
}, function (_ref4) {
  var background = _ref4.background;
  return background;
}, function (_ref5) {
  var fontFamily = _ref5.fontFamily;
  return fontFamily;
}, function (_ref6) {
  var fontSize = _ref6.fontSize;
  return fontSize;
}, function (_ref7) {
  var padding = _ref7.padding;
  return padding;
}, function (_ref8) {
  var margin = _ref8.margin;
  return margin;
}, function (_ref9) {
  var justifyContent = _ref9.justifyContent;
  return justifyContent;
});
var Dropdown = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  width: ", ";\n  font-size: ", "px;\n  font-family: ", ";\n  position: absolute;\n  top: 100%;\n  margin-top: 0.8rem;\n  z-index: 10;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  border-radius: 0.4rem;\n  background: var(--surface-default, #fff);\n"])), function (_ref10) {
  var buttonWidth = _ref10.buttonWidth;
  return buttonWidth;
}, function (_ref11) {
  var fontSize = _ref11.fontSize;
  return fontSize;
}, function (_ref12) {
  var fontFamily = _ref12.fontFamily;
  return fontFamily;
});
var GroupTitle = styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  width: ", ";\n  font-size: ", "px;\n  font-family: ", ";\n  display: flex;\n  height: 3rem;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  border-radius: 0.4rem 0.4rem 0rem 0rem;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.1);\n  background: #f0f0f0;\n  font-style: normal;\n  font-weight: 600;\n"])), function (_ref13) {
  var buttonWidth = _ref13.buttonWidth;
  return buttonWidth;
}, function (_ref14) {
  var fontSize = _ref14.fontSize;
  return fontSize;
}, function (_ref15) {
  var fontFamily = _ref15.fontFamily;
  return fontFamily;
});
var GroupItem = styled.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  width: ", ";\n  font-size: ", "px;\n  font-family: ", ";\n  display: flex;\n  height: 3rem;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  background: #f0f0f0;\n  cursor: pointer;\n  font-style: normal;\n  font-weight: 400;\n"])), function (_ref16) {
  var buttonWidth = _ref16.buttonWidth;
  return buttonWidth;
}, function (_ref17) {
  var fontSize = _ref17.fontSize;
  return fontSize;
}, function (_ref18) {
  var fontFamily = _ref18.fontFamily;
  return fontFamily;
});
var GroupCon = styled.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  width: 100%;\n"])));

var SubscriptionUpsell = function SubscriptionUpsell(_ref) {
  var offer = _ref.offer,
      cartIndex = _ref.cartIndex,
      isMobile = _ref.isMobile,
      handleSubscriptionButtonApiRequest = _ref.handleSubscriptionButtonApiRequest,
      handleGroupItemApiRequest = _ref.handleGroupItemApiRequest,
      initialState = _ref.initialState,
      _ref$isDrawer = _ref.isDrawer,
      isDrawer = _ref$isDrawer === void 0 ? false : _ref$isDrawer;

  var _useState = useState('idle'),
      _useState2 = _slicedToArray(_useState, 2),
      subscriptionStatus = _useState2[0],
      setSubscriptionStatus = _useState2[1]; // ['idle', 'upgrading', 'downgrading'


  var _useState3 = useState(0),
      _useState4 = _slicedToArray(_useState3, 2),
      previousGroupIndex = _useState4[0],
      setPreviousGroupIndex = _useState4[1];

  var _useState5 = useState(0),
      _useState6 = _slicedToArray(_useState5, 2),
      previousPlanIndex = _useState6[0],
      setPreviousPlanIndex = _useState6[1];

  var _useState7 = useState(null),
      _useState8 = _slicedToArray(_useState7, 2),
      selectedPlan = _useState8[0],
      setSelectedPlan = _useState8[1];

  var _useState9 = useState(false),
      _useState10 = _slicedToArray(_useState9, 2),
      showDropdown = _useState10[0],
      setShowDropdown = _useState10[1];

  var _useState11 = useState(false),
      _useState12 = _slicedToArray(_useState11, 2),
      isDropdownOpen = _useState12[0],
      setIsDropdownOpen = _useState12[1];

  var _offer$subscription$c = offer.subscription.cartItemsSubscriptionData.find(function (item) {
    return item.cartIndex === cartIndex;
  }),
      sellingPlanGroups = _offer$subscription$c.sellingPlanGroups,
      variantID = _offer$subscription$c.variantID;

  var _useDynamicImage = useDynamicImage('downIcon'),
      downIcon = _useDynamicImage.image;

  var dropdownRef = useRef(null);
  useEffect(function () {
    setPreviousGroupIndex(initialState.previousGroupIndex);
    setPreviousPlanIndex(initialState.previousPlanIndex);
    setSelectedPlan(initialState.selectedPlan);
    setShowDropdown(initialState.showDropdown);
  }, [initialState]); // This effect adds a click event listener to the window when the dropdown is open.

  useEffect(function () {
    var handleOutsideClick = function handleOutsideClick(event) {
      // Check if the click event is outside the dropdown area
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };

    if (isDropdownOpen) {
      window.addEventListener('click', handleOutsideClick);
    } // Cleanup the event listener when the component unmounts or the dropdown closes.


    return function () {
      window.removeEventListener('click', handleOutsideClick);
    };
  }, [isDropdownOpen]);
  var theme = offer.theme,
      isShowSubscriptionDowngrade = offer.isShowSubscriptionDowngrade,
      subscription = offer.subscription;
  var subscriptionButtonText = subscription.cartItemsSubscriptionData[cartIndex].subscriptionButtonText;
  var defalutSellingPlanGroupIndex = subscription.cartItemsSubscriptionData[cartIndex].defalutSellingPlanGroupIndex || 0;
  var defalutSellingPlanGroupPlanIndex = subscription.cartItemsSubscriptionData[cartIndex].defalutSellingPlanGroupPlanIndex || 0;

  var handleButtonClick = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(e) {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              e.preventDefault();
              e.stopPropagation();
              setSubscriptionStatus('upgrading');
              handleSubscriptionButtonApiRequest(e, function () {
                setSelectedPlan(sellingPlanGroups[defalutSellingPlanGroupIndex].sellingPlans[defalutSellingPlanGroupPlanIndex]);
                setSubscriptionStatus('idle');
                setShowDropdown(true);
              });

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleButtonClick(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  var toggleDropdown = function toggleDropdown(e) {
    e.preventDefault();
    e.stopPropagation();
    setIsDropdownOpen(function (prev) {
      return !prev;
    });
  };

  var handleGroupItemClick = function handleGroupItemClick(plan, currentGroupIndex, currentPlanIndex) {
    setIsDropdownOpen(false);

    if (plan.planText === 'one-time-only') {
      setShowDropdown(false);
      setSubscriptionStatus('downgrading');
      handleGroupItemApiRequest(plan, function () {
        setSubscriptionStatus('idle');
      });
    } else {
      if (currentGroupIndex === previousGroupIndex) {
        if (currentPlanIndex >= previousPlanIndex) {
          setSubscriptionStatus('upgrading');
        } else {
          setSubscriptionStatus('downgrading');
        }
      } else if (currentGroupIndex > previousGroupIndex) {
        setSubscriptionStatus('upgrading');
      } else {
        setSubscriptionStatus('downgrading');
      }

      setPreviousGroupIndex(currentGroupIndex);
      setPreviousPlanIndex(currentPlanIndex);
      handleGroupItemApiRequest(plan, function () {
        setSubscriptionStatus('idle');
        setSelectedPlan(plan);
      });
    }
  };

  var buttonStyles = {
    buttonWidth: getButtonWidth({
      theme: theme,
      isDrawer: isDrawer,
      isMobile: isMobile
    }),
    buttonHeight: getButtonHeight({
      theme: theme,
      isDrawer: isDrawer,
      isMobile: isMobile
    }),
    buttonRadius: getButtonRadius({
      theme: theme,
      isDrawer: isDrawer,
      isMobile: isMobile
    }),
    fontSize: getButtonFontSize({
      theme: theme,
      isMobile: isMobile
    }),
    background: theme.subscriptionButtonColor,
    fontFamily: theme.subscriptionButtonTextFontFamily,
    padding: theme.subscriptionButtonPadding,
    margin: theme.subscriptionButtonMargin,
    justifyContent: theme.subscriptionButtonTextAlignment
  };
  var dropdownStyles = {
    buttonWidth: getButtonWidth({
      theme: theme,
      isDrawer: isDrawer,
      isMobile: isMobile
    }),
    fontSize: getButtonFontSize({
      theme: theme,
      isMobile: isMobile
    }),
    fontFamily: theme.subscriptionButtonDropdownFontFamily
  };
  return /*#__PURE__*/React.createElement(ButtonCon, {
    className: "mr_subs_upsell_embedded_widget"
  }, showDropdown ? /*#__PURE__*/React.createElement(React.Fragment, null, isDropdownOpen ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, _extends({
    className: "mr-subs_upsell_button--dropdown-open"
  }, buttonStyles, {
    onClick: toggleDropdown
  }), "".concat(selectedPlan.planText, "/s"), /*#__PURE__*/React.createElement(MImage, {
    src: downIcon
  })), /*#__PURE__*/React.createElement(Dropdown, _extends({
    className: "mr-subs_upsell_dropdown",
    ref: dropdownRef
  }, dropdownStyles), isShowSubscriptionDowngrade && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(GroupTitle, _extends({
    className: "mr_dropdown_group_title"
  }, dropdownStyles), theme.oneTimeGroupOption), /*#__PURE__*/React.createElement(GroupItem, _extends({
    onClick: function onClick(e) {
      e.preventDefault();
      e.stopPropagation();
      handleGroupItemClick({
        planText: 'one-time-only'
      });
    }
  }, dropdownStyles, {
    className: "mr_dropdown_group_item"
  }), theme.oneTimeOptionText)), sellingPlanGroups.map(function (group, groupIndex) {
    return /*#__PURE__*/React.createElement(GroupCon, {
      className: "mr_dropdown_groups",
      key: variantID
    }, /*#__PURE__*/React.createElement(GroupTitle, _extends({
      className: "mr_dropdown_group_title"
    }, dropdownStyles), group.groupText), group.sellingPlans.map(function (plan, planIndex) {
      return /*#__PURE__*/React.createElement("div", {
        key: plan.id,
        className: "mr_dropdown_group"
      }, /*#__PURE__*/React.createElement(GroupItem, _extends({
        onClick: function onClick(e) {
          e.preventDefault();
          e.stopPropagation();
          handleGroupItemClick(plan, groupIndex, planIndex);
        }
      }, dropdownStyles, {
        className: "mr_dropdown_group_item"
      }), "".concat(plan.planText, "/s")));
    }));
  }))) : /*#__PURE__*/React.createElement(Button, _extends({}, buttonStyles, {
    onClick: toggleDropdown,
    disabled: subscriptionStatus !== 'idle',
    className: "mr-subs_upsell_button--dropdown-close"
  }), subscriptionStatus === 'upgrading' && theme.subscriptionButtonUpgradingText, subscriptionStatus === 'downgrading' && theme.subscriptionButtonDowngradingText, subscriptionStatus !== 'downgrading' && subscriptionStatus !== 'upgrading' && /*#__PURE__*/React.createElement(React.Fragment, null, "".concat(selectedPlan.planText, "/s"), /*#__PURE__*/React.createElement(MImage, {
    src: downIcon
  })))) : /*#__PURE__*/React.createElement(Button, _extends({}, buttonStyles, {
    onClick: handleButtonClick,
    disabled: subscriptionStatus !== 'idle',
    className: "mr-subs_upsell_button--dropdown-close"
  }), subscriptionStatus === 'idle' && subscriptionButtonText, subscriptionStatus === 'upgrading' && theme.subscriptionButtonUpgradingText, subscriptionStatus === 'downgrading' && theme.subscriptionButtonDowngradingText));
};

function getButtonWidth(_ref3) {
  var theme = _ref3.theme,
      isDrawer = _ref3.isDrawer,
      isMobile = _ref3.isMobile;

  if (isDrawer) {
    switch (theme.subscriptionButtonCartDrawerWidth) {
      case '0':
        return '100%';

      default:
        return "".concat(theme.subscriptionButtonCartDrawerWidth, "px");
    }
  }

  if (isMobile) {
    switch (theme.subscriptionButtonMobileWidth) {
      case '0':
        return '100%';

      default:
        return "".concat(theme.subscriptionButtonMobileWidth, "px");
    }
  }

  return "".concat(theme.subscriptionButtonWidth, "px");
}

function getButtonHeight(_ref4) {
  var theme = _ref4.theme,
      isDrawer = _ref4.isDrawer,
      isMobile = _ref4.isMobile;
  if (isDrawer) return theme.subscriptionButtonCartDrawerHeight;
  if (isMobile) return theme.subscriptionButtonMobileHeight;
  return theme.subscriptionButtonHeight;
}

function getButtonRadius(_ref5) {
  var theme = _ref5.theme,
      isDrawer = _ref5.isDrawer,
      isMobile = _ref5.isMobile;
  if (isDrawer) return theme.subscriptionButtonCartDrawerRadius;
  if (isMobile) return theme.subscriptionButtonMobileRadius;
  return theme.subscriptionButtonRadius;
}

function getButtonFontSize(_ref6) {
  var theme = _ref6.theme,
      isMobile = _ref6.isMobile;
  if (isMobile) return theme.subscriptionButtonTextMobileFontSize;
  return theme.subscriptionButtonTextFontSize;
}

SubscriptionUpsell.propTypes = {
  mrCart: PropTypes.array,
  offer: PropTypes.object,
  cartIndex: PropTypes.number,
  handleSubscription: PropTypes.func,
  isMobile: PropTypes.bool,
  handleSubscriptionButtonApiRequest: PropTypes.func,
  handleGroupItemApiRequest: PropTypes.func,
  initialState: PropTypes.object,
  isDrawer: PropTypes.bool
};

var getDescriptionText = function getDescriptionText(_ref) {
  var discountType = _ref.discountType,
      descriptionText = _ref.descriptionText,
      currencyFormat = _ref.currencyFormat,
      currencySymbol = _ref.currencySymbol,
      decimalSymbol = _ref.decimalSymbol,
      thousandSeparator = _ref.thousandSeparator,
      vdOptions = _ref.vdOptions;
  var result = descriptionText;
  vdOptions.forEach(function (_ref2) {
    var minValue = _ref2.minValue,
        discountValue = _ref2.discountValue;
    result = result.replace('{{quantity}}', minValue.toString());

    if (discountType === 'percentage') {
      result = result.replace('{{discount}}', "".concat(discountValue, "%"));
    } else {
      var amount = getAmountDisplay({
        currencyFormat: currencyFormat,
        currencySymbol: currencySymbol,
        amount: discountValue,
        decimalSymbol: decimalSymbol,
        thousandSeparator: thousandSeparator
      });
      result = result.replace('{{discount}}', amount);
    }
  });
  return result;
};

var VDGroup = function VDGroup(_ref3) {
  var vdGroupOfItemsPageURL = _ref3.vdGroupOfItemsPageURL,
      isShowVDViewProductsButton = _ref3.isShowVDViewProductsButton,
      theme = _ref3.theme,
      isMobile = _ref3.isMobile,
      vdOptions = _ref3.vdOptions,
      discountType = _ref3.discountType,
      currencyFormat = _ref3.currencyFormat,
      currencySymbol = _ref3.currencySymbol,
      decimalSymbol = _ref3.decimalSymbol,
      thousandSeparator = _ref3.thousandSeparator;
  var optionForValueExtraction = vdOptions.length && vdOptions[vdOptions.length - 1];
  var minValue = optionForValueExtraction.minValue,
      discountValue = optionForValueExtraction.discountValue;
  var descriptionText = getDescriptionText({
    minValue: minValue,
    discountValue: discountValue,
    discountType: discountType,
    descriptionText: theme.vdGroupDescriptionText,
    currencyFormat: currencyFormat,
    currencySymbol: currencySymbol,
    decimalSymbol: decimalSymbol,
    thousandSeparator: thousandSeparator,
    vdOptions: vdOptions
  });
  var descriptionTextStyles = {
    fontSize: isMobile ? theme.vdGroupDescriptionMobileFontSize : theme.vdGroupDescriptionFontSize,
    fontFamily: theme.vdGroupDescriptionFontFamily,
    padding: isMobile ? theme.vdGroupDescriptionMobilePadding : theme.vdGroupDescriptionPadding,
    margin: isMobile ? theme.vdGroupDescriptionMobileMargin : theme.vdGroupDescriptionMargin,
    color: theme.vdGroupDescriptionTextColor,
    fontWeight: theme.vdGroupDescriptionFontWeight,
    textAlignment: theme.vdGroupDescriptionTextAlignment,
    fontStyle: theme.vdGroupDescriptionFontStyle,
    textDecoration: theme.vdGroupDescriptionTextDecoration,
    width: isShowVDViewProductsButton ? 'auto' : '100%'
  };
  var titleTextStyles = {
    fontSize: isMobile ? theme.offerHeaderMobileFontSize : theme.offerHeaderFontSize,
    fontFamily: theme.offerHeaderFontFamily,
    padding: isMobile ? theme.offerHeaderMobilePadding : theme.offerHeaderPadding,
    margin: isMobile ? theme.offerHeaderMobileMargin : theme.offerHeaderMargin,
    color: theme.offerHeaderTextColor,
    fontWeight: theme.offerHeaderFontWeight,
    textAlignment: theme.offerHeaderTextAlignment,
    fontStyle: theme.offerHeaderFontStyle,
    textDecoration: theme.offerHeaderTextDecoration
  };
  var buttonStyles = {
    padding: isMobile ? theme.vdGroupViewProductButtonMobilePadding : theme.vdGroupViewProductButtonPadding,
    margin: isMobile ? theme.vdGroupViewProductButtonMobileMargin : theme.vdGroupViewProductButtonMargin,
    height: isMobile ? theme.vdGroupViewProductButtonMobileHeight : theme.vdGroupViewProductButtonHeight,
    width: isMobile ? theme.vdGroupViewProductButtonMobileWidth : theme.vdGroupViewProductButtonWidth,
    radius: isMobile ? theme.vdGroupViewProductButtonMobileRadius : theme.vdGroupViewProductButtonRadius,
    bgColor: theme.vdGroupViewProductButtonColor,
    fontSize: isMobile ? theme.vdGroupViewProductButtonMobileFontSize : theme.vdGroupViewProductButtonFontSize,
    fontFamily: theme.vdGroupViewProductButtonFontFamily,
    color: theme.vdGroupViewProductButtonTextColor,
    fontWeight: theme.vdGroupViewProductButtonFontWeight,
    textAlignment: theme.vdGroupViewProductButtonTextAlignment,
    fontStyle: theme.vdGroupViewProductButtonFontStyle,
    textDecoration: theme.vdGroupViewProductButtonTextDecoration,
    buttonStyle: theme.vdGroupViewProductButtonStyle
  };
  var widgetStyles = {
    padding: isMobile ? theme.widgetMobilePadding : theme.widgetPadding,
    margin: isMobile ? theme.widgetMobileMargin : theme.widgetMargin,
    bgColor: theme.offerBackgroundColor,
    borderWidth: theme.offerBorderWidth,
    borderColor: theme.offerBorderColor,
    width: isMobile ? theme.vdOptionBannerMobileWidth : theme.vdOptionBannerWidth,
    height: isMobile ? theme.vdOptionBannerMobileHeight : theme.vdOptionBannerHeight
  };

  var clickHandler = function clickHandler(e) {
    e.preventDefault();
    var isUrlStartingWithHttp = vdGroupOfItemsPageURL.startsWith('https://') || vdGroupOfItemsPageURL.startsWith('http://');
    var urlToOpen = "".concat(!isUrlStartingWithHttp ? '//' : '').concat(vdGroupOfItemsPageURL);
    window.open(urlToOpen, '_blank');
  };

  return /*#__PURE__*/React.createElement(WidgetContainer, _extends({}, widgetStyles, {
    className: "mr-embedded-widget mr-embedded-widget--vd-group"
  }), /*#__PURE__*/React.createElement(FlexDiv, {
    flexDir: "column",
    gap: "12px",
    className: "mr-vd-group__content"
  }, /*#__PURE__*/React.createElement(MdText, {
    fontSize: "".concat(titleTextStyles.fontSize, "px"),
    alignment: titleTextStyles.textAlignment,
    color: titleTextStyles.color,
    fontFamily: titleTextStyles.fontFamily
  }, theme.offer_header_text), /*#__PURE__*/React.createElement(FlexDiv, {
    ai: "top",
    width: "100%",
    jc: "space-between",
    gap: "4px",
    className: "mr-vd-group-content__footer"
  }, /*#__PURE__*/React.createElement(MdText, {
    fontSize: "".concat(descriptionTextStyles.fontSize, "px"),
    alignment: descriptionTextStyles.textAlignment,
    color: descriptionTextStyles.color,
    fontFamily: descriptionTextStyles.fontFamily
  }, descriptionText), isShowVDViewProductsButton && /*#__PURE__*/React.createElement(Button$1, _extends({
    onClick: clickHandler
  }, buttonStyles, {
    className: "mr-vd-group-footer__button"
  }), theme.vdGroupViewProductButtonText))));
};
VDGroup.propTypes = {
  vdGroupOfItemsPageURL: PropTypes.string,
  isShowVDViewProductsButton: PropTypes.bool,
  theme: PropTypes.object,
  isMobile: PropTypes.bool,
  vdOptions: PropTypes.array,
  discountType: PropTypes.string,
  decimalSymbol: PropTypes.string,
  thousandSeparator: PropTypes.string,
  currencySymbol: PropTypes.string,
  currencyFormat: PropTypes.string
};

var img$4 = "data:image/png;base64,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";

var discount = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': img$4
});

var img$3 = "data:image/png;base64,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";

var gift = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': img$3
});

var img$2 = "data:image/png;base64,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";

var shipping = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': img$2
});

var img$1 = "data:image/png;base64,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";

var spLogo = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': img$1
});

var img = "data:image/svg+xml,%3csvg width='21' height='20' viewBox='0 0 21 20' fill='none' xmlns='http://www.w3.org/2000/svg' %3e %3cpath d='M13.5983 8L7.40169 8C6.65069 8 6.23001 8.75351 6.69399 9.2676L9.79231 12.7006C10.1526 13.0998 10.8474 13.0998 11.2077 12.7006L14.306 9.2676C14.77 8.75351 14.3493 8 13.5983 8Z' fill='%23323232' /%3e %3cpath d='M13.5983 8L7.40169 8C6.65069 8 6.23001 8.75351 6.69399 9.2676L9.79231 12.7006C10.1526 13.0998 10.8474 13.0998 11.2077 12.7006L14.306 9.2676C14.77 8.75351 14.3493 8 13.5983 8Z' fill='%23999DA1' /%3e %3cpath d='M13.5983 8L7.40169 8C6.65069 8 6.23001 8.75351 6.69399 9.2676L9.79231 12.7006C10.1526 13.0998 10.8474 13.0998 11.2077 12.7006L14.306 9.2676C14.77 8.75351 14.3493 8 13.5983 8Z' fill='%235C5F62' /%3e %3cpath d='M13.5983 8L7.40169 8C6.65069 8 6.23001 8.75351 6.69399 9.2676L9.79231 12.7006C10.1526 13.0998 10.8474 13.0998 11.2077 12.7006L14.306 9.2676C14.77 8.75351 14.3493 8 13.5983 8Z' fill='%23696C6E' /%3e %3cpath d='M13.5983 8L7.40169 8C6.65069 8 6.23001 8.75351 6.69399 9.2676L9.79231 12.7006C10.1526 13.0998 10.8474 13.0998 11.2077 12.7006L14.306 9.2676C14.77 8.75351 14.3493 8 13.5983 8Z' fill='white' /%3e %3c/svg%3e";

var downIcon = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': img
});

export { CVB, ExampleComponent, HelloComponent, ShippingProtection, SubscriptionUpsell, VDGroup, formatWithSymbolAndSeparator, get as getVisitorData };
